<template>
  <table id="mytable" class="w-100 table table-hover bg-white" :class="{ 'table-with-batch-controls': hasAnySelectedTargets() }">
    <thead>
      <TR v-if="ccol.length > 0">
        <th class="text-secondary" scope="colgroup" :colspan="ccol.length + 13">
          <span>
            <button v-if="isopen" class="btn btn-outline-secondary btn-sm pb-1 py-0 mr-1" @click="closeCols()">
              <small>
                <i class="icon-arrow-right"></i>
                <i class="icon-arrow-left"></i>
                {{ $t("lang.button.close") }}
              </small>
            </button>

            <button v-if="!isopen" class="btn btn-outline-secondary btn-sm pb-1 py-0 mr-1" @click="openCols()">
              <small>
                <i class="icon-arrow-left"></i>
                <i class="icon-arrow-right"></i>
                {{ $t("lang.label.open") }}
              </small>
            </button>
          </span>
          {{ $t("lang.mycontacts.mycustomcolumns") }}
        </th>
      </TR>
      <tr>
        <th v-if="checkbox && !fromContacts" scope="col" style="width: 10px; border-top: 0px">
          <div class="">
            <div class="btn-group">
              <button type="button" :class="allselected || allpageselected ? 'bg-primary' : ''"
                class="btn btn-sm btn-white" data-toggle="dropdown">
                <span class="">
                  <i v-if="allselected || allpageselected" class="text-white icon-check-circle"></i>
                  <i v-if="!allselected && !allpageselected" class="icon-circle-o"></i>
                </span>
              </button>
              <button type="button" :class="allselected || allpageselected ? 'bg-primary' : ''"
                class="border btn btn-sm btn-white dropdown-toggle" data-toggle="dropdown" aria-haspopup="true"
                aria-expanded="false"></button>
              <div class="dropdown-menu dropdown-menu-right">
                <button @click="toggleAllPages()" :class="allselected ? 'text-primary' : ''" class="dropdown-item"
                  type="button">
                  <small>{{ $t("lang.mycontacts.selectallpages") }}
                    <i v-if="model.noselectall" class="icon-lock"></i>
                  </small>
                  <i v-if="allselected" class="text-primary icon-checkmark"></i>
                </button>
                <button @click="toggleAll()" :class="allpageselected ? 'text-primary' : ''" class="dropdown-item"
                  type="button">
                  <small>{{ $t("lang.mycontacts.selectonlypages") }} </small>
                  <i v-if="allpageselected" class="text-primary icon-checkmark"></i>
                </button>
              </div>
            </div>
          </div>
        </th>

        <!-- header selectora para vista contacts > orders -->
        <th v-if="checkbox && fromContacts" class="text-primary" scope="col" style="border-top: 0px">
          <span class="mr-1 rounded-pill pr-1">
            Select 
          </span>
          <button type="button" :class="allselected || allpageselected ? 'bg-primary' : ''"
            class="border btn btn-sm btn-white dropdown-toggle" data-toggle="dropdown" aria-haspopup="true"
            aria-expanded="false"></button>
          <div class="dropdown-menu dropdown-menu-right">
            <button @click="toggleAllPages()" :class="model.allselected ? 'text-primary' : ''" class="dropdown-item"
              type="button">
              <small>{{ $t("lang.mycontacts.selectallpages") }}
                <i v-if="model.noselectall" class="icon-lock"></i>
              </small>
              <i v-if="model.allselected" class="text-primary icon-checkmark"></i>
            </button>
            <button @click="toggleAll()" :class="model.allpageselected ? 'text-primary' : ''" class="dropdown-item"
              type="button">
              <small>{{ $t("lang.mycontacts.selectonlypages") }} </small>
              <i v-if="model.allpageselected" class="text-primary icon-checkmark"></i>
            </button>
          </div>
        </th>

        <th :class="!isopen ? 'closed' : ''" class="" v-for="(customCol, keyc) in ccol">
          <span class="text-primary">{{ customCol }}</span>
        </th>

        <template v-for="(header, keyh) in headers" v-if="
          header.role_id == undefined || header.role_id == currentUser.role_id
        ">
          <th :key="'header' + keyh" :style="header.size ? 'width:' + header.size : (header.percentage ? 'width:' + header.percentage + ';min-width:' + header.percentage : '')" v-if="
            (header.visible == undefined || header.visible) &&
            (header.permission == undefined ||
              hasPermissions(header.permission))
          " class="border-top-0">
            <span v-if="header.icon !== undefined">
              <img width="20px" :src="require('@/assets/images/' + header.icon)" />
            </span>

            <i
              v-if="header.icon_class"
              :class="header.icon_class"
              :title="header.title || header.label"
            ></i>

            <span v-if="header.orderby == undefined && !header.icon_class">
              {{ header.label }}
              <span
                v-if="header.badge"
                class="badge badge-primary text-white ml-1"
                style="font-size: 9px; vertical-align: middle;"
              >{{ header.badge }}</span>
            </span>
            <span v-else v-bind:class="header.orderby ? 'text-primary' : ''" @click="
              orderBy(header.field, header.order), orderActive(header.field)
              "><i class="icon-arrow-down" v-if="header.order == 'ASC'" />
              <i class="icon-arrow-up" v-else />
              {{ header.label }}
              <span
                v-if="header.badge"
                class="badge badge-primary text-white ml-1"
                style="font-size: 9px; vertical-align: middle;"
              >{{ header.badge }}</span>
            </span>
            <Tooltip v-if="header.tooltip_value" :text="header.tooltip_value" :width="'auto'">
              <i class="d-inline ml-2 cursor-pointer text-secondary ml-2 fa " :class="header.tooltip_icon"></i>
            </Tooltip>
          </th>
        </template>
      </tr>
    </thead>
    
    <!-- Batch Controls - Fixed at top, only show when targets are selected -->
    <div v-if="hasAnySelectedTargets()" class="batch-controls-fixed">
      <div class="d-flex align-items-end float-right">
       
        <div>
          <button 
            @click="processAllSelectedTargets()" 
            :disabled="batchProcessing"
            class="btn btn-success mr-2">
            <span v-if="batchProcessing" class="spinner-border spinner-border-sm mr-2"></span>
            <i class="icon-play"></i> Process Selected ({{ getTotalSelectedCount() }})
          </button>
          
          <button @click="clearAllTargetsInTable()" class="btn btn-sm btn-outline-secondary mr-2">
            <i class="icon-close"></i> Clear All
          </button>
        </div>
      </div>
    </div>
    
    <tbody>
      <tr v-for="(row, trkey) in data" @click="toggleItem(row.id, row.business_contact_status_id)"
        :class="[isActive(row.id) ? 'table-primary' : '', row.row_highlight_class || '']"
        v-if="notselect || row.role_id == undefined || row.role_id == currentUser.role_id">
        <td v-if="checkbox && !fromContacts" class="cursor-pointer">
          <div>
            <div class="form-check">
              <input class="form-check-input" type="checkbox" value="" :id="'flexCheckDefault-' + row.id"
                :checked="isActive(row.id)" />
            </div>
          </div>
        </td>

        <td class="overflowhide" v-for="(customColumnValue, keyvalue) in customColumns"
          v-if="hasPermissionColumn(cols[keyvalue])" :class="isOpenClass(keyvalue)">
          <span style="width: 150px" v-if="getRowValues(customColumnValue.id, trkey)">
            <Tooltip :text="getRowValues(customColumnValue.id, trkey)" :width="'auto'">
              {{ getRowValues(customColumnValue.id, trkey) }}
            </Tooltip>
          </span>
        </td>

        <template v-for="(colg, key) in cols" v-if="hasPermissionColumn(cols[key])">
          <td :key="'row' + key" v-if="
            headers[key] &&
            (headers[key].permission == undefined ||
              hasPermissions(headers[key].permission))
          " :class="headers[key].class" :style="headers[key].percentage !== undefined
                ? 'width:' + headers[key].percentage + ';min-width:' + headers[key].percentage
                : (headers[key].size !== undefined
                  ? 'width:' + headers[key].size + ';min-width:' + headers[key].size
                  : '')
              ">
            <span v-for="col in colg" @click="gotoLink(col.type, row[col.link])" :class="col.type == 'link' && row[col.link]
                ? 'text-primary cursor-pointer'
                : ''
              " :style="headers[key].size !== undefined
                  ? 'width:' + headers[key].size
                  : ''
                ">
              <span
                v-if="col.type == 'icon' && (!col.adminOnly || currentUser.role_id == 1)"
                class="d-inline-flex align-items-center justify-content-center cursor-pointer"
                :class="[
                  col.neutralSituationIcon
                    ? 'ml-1'
                    : 'situation-tone-cell justify-content-center rounded',
                  col.toneFrom ? 'situation-tone-cell--has-tone' : '',
                  situationToneCellClass(row, col),
                ]"
                :title="situationToneTitle(row, col)"
                @click.stop="handleType2(col, row)"
              >
                <span
                  v-if="col.toneFrom && row[col.toneFrom] === 'loading'"
                  class="spinner-border spinner-border-sm situation-tone-spinner"
                  role="status"
                  aria-hidden="true"
                />
                <template v-else>
                  <i :class="col.icon_class" aria-hidden="true" />
                  <i
                    v-if="situationToneOverlayClass(row, col)"
                    class="icon-exclamation-triangle situation-tone-badge"
                    :class="situationToneOverlayClass(row, col)"
                    aria-hidden="true"
                  />
                </template>
              </span>

              <span class="mr-2" v-for="icon in col.icons" v-if="!row[icon.icon_if] && icon.icon_false">
                <Tooltip :text="icon.tooltip_false_value === undefined
                    ? icon.tooltip_false
                    : row[icon.tooltip_false_value]
                  " :width="'auto'" v-if="icon.tooltip_false || icon.tooltip_false_value">
                  <i class="d-inline ml-2 cursor-pointer" :class="icon.icon_false"></i>
                </Tooltip>
                <i v-else class="d-inline ml-2 cursor-pointer" :class="icon.icon_false"></i>
              </span>

              <span class="mr-2" v-for="icon in col.icons" v-if="
                row[col.value] == icon.icon_if_value &&
                icon.icon_if_value != null
              ">
                <Tooltip :text="icon.tooltip_true" :width="'auto'" v-if="icon.tooltip_true">
                  <i class="d-inline ml-2 cursor-pointer" :class="icon.icon_true"></i>
                </Tooltip>
                <i v-else class="d-inline ml-2 cursor-pointer" :class="icon.icon_true"></i>
              </span>

              <span class="mr-2" v-for="icon in col.icons" v-if="
                (row[icon.icon_if] && icon.icon_true) ||
                (icon.icon_if_value != null && row[col.if_value] == icon.icon_if_value)
              ">
                <Tooltip :text="icon.tooltip_true_value === undefined
                    ? icon.tooltip_true
                    : row[icon.tooltip_true_value]
                  " :width="'auto'" v-if="icon.tooltip_true || icon.tooltip_true_value">
                  <i class="d-inline ml-2 cursor-pointer" :class="icon.icon_true"></i>
                </Tooltip>

                <i v-if="
                  !icon.tooltip_true &&
                  !icon.tooltip_true_value &&
                  icon.icon_if != 'domain'
                " class="d-inline ml-2 cursor-pointer" :class="icon.icon_true"></i>

                <i class="d-inline ml-2 icon-facebook" v-if="
                  icon.icon_if == 'domain' && isFacebook(row[icon.icon_if])
                "></i>
                <i class="d-inline ml-2 icon-globe" v-if="
                  icon.icon_if == 'domain' && !isFacebook(row[icon.icon_if])
                "></i>
              </span>

              <Tooltip :text="getValue(row, col, 'tooltip')" :width="headers[key].size"
                v-if="row[col.tooltip] && col.type != 'email'">
                {{ getValue(row, col) }}
              </Tooltip>

              <span :class="{ 'text-primary font-weight-bold h6': row.totalRow }" :style="col.style" v-if="
                !row[col.tooltip] &&
                col.type != 'email' &&
                col.type != 'router' &&
                col.type != 'emit' &&
                col.type != 'emitConditional' &&                
                col.type != 'itemBadge' &&
                col.type != 'badgeBookingSignal' &&
                col.type != 'image' &&
                col.type != 'peopleNames' &&
                col.type != 'ImageBadge' &&
                col.type != 'image-icon' &&
                col.type != 'imageSet' &&
                col.type != 'imageSetMultipleLines' &&
                col.type != 'imageSetClients' &&
                col.type != 'map' &&
                col.type != 'qty' &&
                col.type != 'itemBadgeConditional' &&
                col.type != 'campaignsBadge' &&
                col.type != 'progressStatus' &&
                col.type != 'targetProblem' &&
                col.type != 'statsBadge' &&
                col.type != 'listBadges' &&
                col.type != 'status' &&
                col.type != 'isAsync' &&
                col.type != 'isComponentAsync' &&
                col.type != 'clientActivity' &&
                col.type != 'html' &&
                col.type != 'claimContactsInformation' &&
                col.type != 'btnAction' &&
                col.type != 'precentage' &&
                col.type != 'checkboxMultiple' &&
                col.type != 'setIcons' &&
                col.type != 'icon' &&
                col.type != 'twoValues' &&
                col.type != 'setIconsString' &&
                col.type != 'time' &&
                col.type != 'targetsList' &&
                col.type != 'withQty' &&
                col.type != 'iconIfPipe' &&
                col.type != 'tooltipNote' &&
                col.type != 'importBatchSummary' &&
                col.type != 'salesridgeImportProgress' &&
                col.type != 'btnIfNotNull' &&
                col.type != 'twoValueParenthesis'&&
                col.type != 'chkBoxContacts' &&
                col.type != 'invoiceFormats' &&
                col.type != 'ContactPreview' &&
                col.type != 'teamsClientFormat' &&
                col.type != 'statusMeeting' &&
                col.type != 'tinyTotalCols' &&
                col.type != 'colorByField' &&
                col.type != 'commentIcon' &&
                col.type != 'CreateMeetingButton' &&
                (!col.loading || (col.loading && !fieldsLoading))
              ">
                <span v-if="
                  getValue(row, col) && col.format && col.format == 'money'
                ">
                  {{ col.simbol }}
                </span>

                <span v-if="col.canBeHidden == 'yes' && row.show && row.show == 'no'">
                  * * *
                </span>
                <span v-else>
                  {{ getValue(row, col) }}
                </span>


                
                <span v-if="
                  getValue(row, col) &&
                  col.format &&
                  col.format == 'percentage'
                ">
                  %
                </span>
              </span>
              <!-- type: colorByField - muestra row[col.value] con badge según row[col.colorByField] y col.colors -->
              <template v-if="col.type == 'colorByField'">
                <span v-if="row.totalRow" class="text-primary font-weight-bold">{{ row[col.value] }}</span>
                <span
                  v-else
                  :class="col.badgeClass || 'badge badge-pill'"
                  :style="col.colors && col.colorByField != null
                    ? 'border-radius: ' + (col.borderRadius != null ? col.borderRadius : '50px') + '; padding: 2px 8px; background-color:' +
                      bgColor(row[col.colorByField], col) +
                      '; color:' + textColor(row[col.colorByField], col) +
                      '; font-size:' + fontSize(row[col.colorByField], col) +
                      '; font-weight: normal;'
                    : ''"
                >
                  {{ row[col.value] }}
                </span>
              </template>

              <!-- type: CreateMeetingButton -->
              <template v-if="col.type == 'CreateMeetingButton'">

                <button
                  v-if="row[col.value3] == 'Passer un appel'"
                  :class="'btn btn-primary btn-sm'"
                  @click="$emit(col.emit, row)"
                  :disabled="
                    !row[col.value1] ||
                    row[col.value1] === '' ||
                    row[col.value1] == 'No meeting' ||
                    row[col.value2] == null ||
                    row[col.value2] === '' ||
                    Number(row[col.value2]) > 0
                  "
                >
                  Créer le meeting
                </button>
                <span v-else>N/A</span>
              </template>

              <!-- type: tinyTotalCols -->
              <template v-if="col.type == 'tinyTotalCols'">
                <span v-if="row.totalRow" class="text-primary font-weight-bold">{{ row[col.value] }}</span>
                <small v-else>{{ row[col.value] }}</small>
              </template>

                <!-- type: withQty -->
                <template v-if="col.type == 'withQty'">
                  
                  <template v-if="row.totalRow">
                    <span  class="text-primary font-weight-bold">
                      {{ row[col.value] }}
                    </span>
                    <span class="ml-1 text-primary font-weight-bold" v-if="col.value">{{ col.symbol }} </span>
                    <span class="ml-1 text-primary font-weight-bold" v-if="row[col.value_qty] != null">
                      ( {{ row[col.value_qty] }} )
                    </span>
                  </template>

                  <template v-else>
                    <template v-if="row[col.value] > 0">
                      <span>
                        {{ row[col.value] }}                     
                      </span>
                      <span class="ml-1" v-if="row[col.value_qty]">{{ col.symbol }} </span>
                      <span class="ml-1" v-if="row[col.value_qty] != null">
                        ( {{ row[col.value_qty] }} )
                      </span>
                  </template>
                  </template>                
              </template>

              <!-- type: statusMeeting -->
              <template v-if="col.type == 'statusMeeting'">
                <Tooltip class="mr-2" :text="'Meeting Date'">{{ row[col.value4] }}</Tooltip>
                <span :class="getClassStatusMeeting(row[col.value1], row[col.value2], row[col.value3], row[col.value5])" class="mx-1">{{
                  getTextStatusMeeting(row[col.value1], row[col.value2])
                }}</span>
              </template>

              <!-- type: teamsClientFormat -->
              <template v-if="col.type == 'teamsClientFormat'">
                <span v-if="col.format == 1">
                  <span v-if="!row.totalRow">
                  <input
                    :id="row[col.value1]"
                    v-model="row[col.value2]"
                    @change="$emit(col.emit)"
                    v-if="row[col.value3] != null"
                    class="ml-2"
                    type="checkbox"
                  />
                  </span> 
                  <span class="text-primary font-weight-bold h6" v-if="row.totalRow">
                    Total 
                  </span>
                </span>
                <span v-if="col.format == 2 && !row.totalRow">
                  Team  {{ row[col.value] }}
                  <span
                    v-if="row[col.value2]"
                    class="ml-2 cursor-pointer"
                    @click="
                      $emit(col.emit, row[col.value1])
                    "
                  >
                    <i class="icon-edit text-primary"></i>
                  </span>
                </span>
                <span v-if="col.format == 3">
                  <template v-if="row[col.value1]">
                    <div
                      v-for="(target, tkey) in row[col.value1].split(',')"
                      :key="tkey"
                    >
                      <div>
                        <span
                          class="badge"
                          :class="getBadgeTargetStatus(row[col.value2])"
                          @click="$emit(col.emit, row[col.btnId])"
                        >
                          {{ target }}
                        </span>
                      </div>
                    </div>
                  </template>
                  <div v-else>-</div>
                </span>
                <span v-if="col.format == 4">
                  <!-- <span :class="row[col.value1] > 0 ? 'badge badge-success font-weight-bold' : row[col.value2] > 0 ? 'badge badge-warning font-weight-bold' : row[col.value3] > 0 ? 'badge badge-danger font-weight-bold' : ''">
                    {{ row[col.value1] > 0 ?  + 'Active' : row[col.value2] > 0 ? 'Warming up' : row[col.value3] > 0 ? 'Resting' : '' }}
                  </span> -->
                  <span v-if="row[col.value] == 'prospectors_warmingup'" class="badge badge-warning">Warning up</span>
                  <span v-if="row[col.value] == 'prospectors_available'" class="badge badge-info">Available</span>
                  <span v-if="row[col.value] == 'prospectors_prospecting'" class="badge badge-success">Prospecting</span>
                </span>
              </template>

              <!-- type: ContactPreview -->
              <template v-if="col.type == 'ContactPreview'">
                <span v-if="col.format == 1">
                  {{ getContactPreviewValue(row, col, col.value2) || "-" }}
                </span>
                <span v-if="col.format == 2">
                  <template v-if="getContactPreviewValueAsString(row, col, col.value2)">
                    <Tooltip 
                      :text="getContactPreviewValueAsString(row, col, col.value2)" 
                      :width="'auto'"
                    >
                      <span>{{ truncateText(getContactPreviewValueAsString(row, col, col.value2), 100) }}</span>
                    </Tooltip>
                  </template>
                  <span v-else>-</span>
                </span>
              </template>

              <!-- type: invoiceFormats -->
              <template v-if="col.type == 'invoiceFormats'">
                <span v-if="col.format == 1">
                  00000{{ row[col.value1] }} 
                  <div class="small">
                    {{ row[col.value2] | moment("DD/MM/YYYY") }}
                  </div>
                  <div
                    class="badge"
                    :class="row[col.value4] || 'badge-primary'"
                  >
                  <span>{{ row[col.value3] }} </span>
                  </div>
                </span>

                <span v-if="col.format == 2">
                  <span class="text-primary mr-1" @click="$emit(col.emit, row[col.value2])">{{ row[col.value1] }} </span>
                  <span class="small">({{ row[col.value2] }}) </span>
                  <div class="small" v-if="row[col.value3]">
                    {{ $t("lang.column.legalrepresentative") }}
                  </div>
                  <div class="small" v-if="row[col.value3]">
                    {{ row[col.value3] }}
                  </div>
                </span>

                <span v-if="col.format == 3">
                  <div v-if="!col.fromRecovering">
                    <span v-if="row[col.value11] == 'bank_transfer' && row[col.value10] == '11'">
                      <span
                        :class="
                          isBankTransferContractualOverdue(row, col)
                            ? 'badge badge-danger font-weight-bold'
                            : 'badge badge-success font-weight-bold'
                        "
                      >
                        {{ bankTransferDaysSinceDateDisplay(row, col) }}
                      </span>
                    </span>

                    <small v-if="row[col.value7] == 'SEPA' && row[col.value6] != null && row[col.value6] == 1" class="icon icon-circle text-success"></small>
                    <small v-if="row[col.value7] == 'SEPA' && row[col.value6] != null && row[col.value6] == 0" class="icon icon-circle text-danger"></small>
                    <div>
                      <small v-if="row[col.value6] != null && row[col.value6] == 0" class="badge badge-success font-weight-bold">NEW</small>
                    </div>
                    <div>
                      <span v-if="col.value3 && col.value4 && col.value5" class="font-weight-bold">
                        {{ row[col.value3] != null ? row[col.value3] : '' }} 
                        {{ row[col.value4] != null ? '(' + row[col.value4] + ')' : '' }} 
                        {{ row[col.value5] != null ? '(' + formatDate(row[col.value5]) + ')' : '' }}
                      </span> 
                      <br />
                      {{ row[col.value2] }} 
                      <button
                        class="align-self-end btn btn-sm btn-theme-bg-transparent ml-2"
                        @click="$emit(col.emit, row[col.btnId])"
                      >
                        <i class="icon-download ml-2"></i>
                      </button>
                    </div>
                  </div>
                  <div v-else>
                    <button
                      class="align-self-end btn btn-sm btn-theme-bg-transparent ml-2"
                      @click="$emit(col.emit, row[col.btnId])"
                    >
                      <i class="icon-download ml-2"></i>
                    </button>
                  </div>
                </span>

                <span v-if="col.format == 4">
                  <button
                    @click="$emit(col.emit, row[col.btnId], 2)"
                    class="btn btn-success"
                    :title="invoiceCollectTitle(row, col)"
                    :disabled="!isInvoiceCardChargeable(row, col)"
                  >
                    <i class="icon-dollar"></i>
                  </button>
                  <template v-if="!col.collectOnly">
                  <button
                    @click="$emit(col.emit, row[col.btnId], 6)"
                    class="btn btn-danger ml-2"
                    title="Cancel"
                    :disabled="![3, 4].includes(row[col.value1])"
                  >
                    <i class="icon-remove"></i>
                  </button>
                  <button
                    @click="$emit(col.emit, row[col.btnId], 4)"
                    class="btn btn-secondary ml-2"
                    title="Exonerate"
                    :disabled="![3, 6].includes(row[col.value1])"
                  >
                    <i class="icon-ban"></i>
                  </button>
                  <button
                    @click="$emit(col.emit, row[col.btnId], 3)"
                    class="btn btn-secondary ml-2"
                    title="Declined"
                    :disabled="
                      !(
                        [5].includes(row[col.value1]) ||
                        (row[col.value1] == 9 && row[col.value11] == 'sepa') ||
                        (row[col.value1] == 11 &&
                          row[col.value11] == 'bank_transfer' &&
                          isBankTransferContractualOverdue(row, col))
                      )
                    "
                  >
                    <i class="icon-frown-o"></i>
                  </button>
                  <button
                    @click="$emit(col.emit, row[col.btnId], 5)"
                    class="btn btn-primary ml-2"
                    title="Paid manually"
                    :disabled="
                      ![3, 4, 6, 9, 11].includes(row[col.value1])
                    "
                  >
                    <i class="icon-thumbs-up"></i>
                  </button>
                  </template>
                </span>

                <span v-if="col.format == 5">
                  {{ row[col.value1] }}
                  <span class="ml-1" v-if="row[col.value2] == 1">
                    <img src="@/assets/images/auction.png" alt="" width="20px">
                  </span>
                </span>
              </template>

              <!-- type: chkBoxContacts -->
              <template v-if="col.type == 'chkBoxContacts'">
                <span v-if="checkbox">
                  <input type="checkbox" value="" :id="'flexCheckDefault-' + row.id" :checked="isActive(row.id)"  @click.stop
                  @change.stop="toggleItem(row.id)"/>
                </span>
              </template>

              <!-- type: twoValueParenthesis -->
              <template v-if="col.type == 'twoValueParenthesis'">
                <span v-if="!col.format">
                  <span v-if="row[col.value1] != null && row[col.value2] != null" class="text-center">
                    <span class="font-weight-bold">{{ row[col.value1] }}</span> {{ '(' + formatDate(row[col.value2]) + ')' }}
                  </span>
                </span>
                <span v-if="col.format && col.format == 1" class="text-center">
                  <span v-if="row[col.value1] == null && row[col.value2] == null">
                    <span class="font-weight-bold badge badge-danger">Apollo <span v-if="col.version">{{ row[col.version] != null ? 'V2' : 'V1'  }}</span></span>
                  </span>
                  <span v-else>
                    <span class="font-weight-bold badge badge-danger" v-if="row[col.value2] != null">FullEnrich {{ row[col.value1] != null ? '(' + formatDate(row[col.value1]) + ')' : '' }} <span v-if="col.version">{{ row[col.version] != null ? 'V2' : 'V1'  }}</span></span> 
                    <span v-else class="font-weight-bold badge badge-success">SalesRidge {{ '(' + formatDate(row[col.value1]) + ')' }} <span v-if="col.version">{{ row[col.version] != null ? 'V2' : 'V1'  }}</span></span>
                  </span>
                </span>
                <span v-if="col.format && col.format == 'rankingRevenueClient'" class="text-center">
                  <span v-if="row.totalRow" class="text-primary font-weight-bold h6"></span>
                  <template v-else>
                    <span class="font-weight-bold">{{ row[col.value1] }}</span>
                    <span
                      v-if="row[col.value2] != null && row[col.value2] !== ''"
                      class="ml-1"
                      :class="{
                        'text-danger': Number(row[col.value2]) > Number(row[col.value1]),
                        'text-success': Number(row[col.value2]) < Number(row[col.value1]),
                        'text-secondary': Number(row[col.value2]) === Number(row[col.value1]),
                      }"
                    >({{ row[col.value2] }})</span>
                  </template>
                </span>
              </template>

              <!-- type: importBatchSummary (import-error SalesRidge batches) -->
              <template v-if="col.type == 'importBatchSummary'">
                <span
                  class="small"
                  :title="row[col.value] || ''"
                  style="cursor: help; white-space: normal;"
                >{{ row[col.value2] || '—' }}</span>
              </template>

              <!-- type: salesridgeImportProgress -->
              <template v-if="col.type == 'salesridgeImportProgress'">
                <SalesridgeImportProgressCell
                  :row="row"
                  :show-enqueue-button="!!col.show_enqueue_button"
                  :show-launch-button="!!col.show_launch_button"
                  @row-updated="$emit('importProgressRowUpdated', $event)"
                  @pipeline-updated="$emit('importPipelineUpdated', $event)"
                />
              </template>

              <!-- type: tooltipNote -->
              <template v-if="col.type == 'tooltipNote'">

                <!-- <span v-if="col.format && col.format == 'clientAffiliationsList'">
                  <span v-if="row[col.value1] == null">
                    <small class="font-weight-bold">NO <Tooltip :text="$t('lang.label.this_client_has_not_affiliations')" :width="'auto'"><i class="icon-info ml-1 mt-1 ml-2 text white bg-secondary p-1"></i></Tooltip></small>
                  </span>
                  <span v-else>
                    <small class="font-weight-bold">YES<Tooltip :text="row[col.value1]" :width="'auto'"><i class="icon-info ml-1 mt-1 ml-2 text white bg-secondary p-1"></i></Tooltip></small>
                  </span>
                </span> -->

                <!-- notes in booker pipe -->
                <span v-if="!col.phoneTool && !col.condition && col.format != 'clientAffiliationsList'">
                  <span v-if="!col.value2 || row[col.value2] == null || row[col.value2] == undefined" class="bg bg-secondary text-white text-center" style="border-radius: 5px; padding: 1px 5px;">
                    <Tooltip :text="row[col.value] != null ? getValue(row, col) : $t('lang.label.notnotes')" :width="'auto'">
                      Info <i class="icon-info ml-1 mt-1 mr-1 text white"></i>
                    </Tooltip>
                  </span>
                  <span v-else :class="notesByLevel(row[col.value2])" style="border-radius: 5px; padding: 1px 5px;">
                    <Tooltip :text="row[col.value] != null ? getValue(row, col) : $t('lang.label.notnotes')" :width="'auto'">
                      {{row[col.value2]}}/10 <i class="icon-info ml-1 mt-1 mr-1 text white"></i>
                    </Tooltip>
                  </span>
                </span>

                <!-- phone to campaign email by step -->
                <span v-else>
                  <span v-if="!col.condition">
                    <span v-if="row[col.value] != null && row[col.value2] == 'FullEnrich'">
                      <Tooltip :text="'Created ' + row[col.value3] + ' (' + (row[col.value2] ? row[col.value2] :  'No source available') +')'" :width="'auto'">
                        <span class="font-weight-bold">{{ row[col.value] }}</span>
                      </Tooltip>
                    </span>
                    <span v-else-if="row[col.value] != null && (row[col.value2] == null || row[col.value2] != 'FullEnrich')">
                      <span class="font-weight-bold">{{ row[col.value] }}</span>
                    </span>
                    <span v-else-if="(row[col.value] == null || row[col.value]=='') && row[col.value2] == 'FullEnrich'">
                      <Tooltip :text="'Last try at ' + row[col.value4]" :width="'auto'">
                        <span class="bg bg-warning text-white mb-1 px-1 py-1 rounded-pill">Not Found</span>
                      </Tooltip>
                    </span>
                  </span>
                  <!-- tooltip en caso de querer usarlo con algun condicional -->
                  <span v-else>
                    <span v-if="row[col.condition] == false">
                      <Tooltip :text="row[col.value]" :width="'auto'">
                        <i class="d-inline ml-2 cursor-pointer text-secondary ml-2 fa " :class="col.tooltip_icon"></i>
                      </Tooltip>
                    </span>
                  </span>
                </span>
              </template>

		          <!-- type: iconIfPipe -->
              <template v-if="col.type == 'iconIfPipe'">
                <span v-if="!col.format">
                  <span v-if="getValue(row, col) == 1 || getValue(row, col) == 2">
                    <i v-if="row[col.value2] > 30" class="icon-clock text-danger icon-small"></i>
                  </span>
                  <span v-else>
                    <span v-if="getValue(row, col) == 3 && col.value2 == 'starting_date'">
                      <i v-if="row[col.value2] && row[col.value2].slice(0, 10) <= new Date().toISOString().slice(0, 10)" class="icon-exclamation-triangle text-danger icon-small"></i>
                    </span>
                  </span>
                </span>
                <span v-else-if="col.format && col.format == 'has_cold_tasks'">
                  <small class="d-flex flex-column">
                    <span v-if="row[col.value1] != null && row[col.value1] > 0">
                      <i class="icon icon-clipboard text-warning icon-small ml-1" style="width: 17px; height: 17px; line-height: 14px;">
                      </i>
                      <span class="font-weight-bold ml-1">{{ row[col.value2] }}</span>
                    </span>
                    <span v-if="row[col.value3] != null && row[col.value3] > 0">
                      <Tooltip :text="row[col.value5]" :width="'auto'" v-if="row[col.value5] != null">
                        <span class="d-inline-flex align-items-center mt-1">
                          <span class="ml-1 p-0 circle text-center text-white bg-success" 
                                style="width: 14px; height: 14px; line-height: 14px; border-radius: 50%;">
                            {{ row[col.value3] }}
                          </span>
                          <span class="font-weight-bold ml-1">{{ row[col.value4] }}</span>
                        </span>
                      </Tooltip>
                    </span>
                  </small>
                </span>
                <!-- metodo generico para insertar un icono segun sea el caso -->
                <span v-if="col.format && col.format == 'subscription_status'">
                  <span v-if="!row.totalRow">
                    <Tooltip v-show="col.withTooltip" :text="row[col.valueTooltip]" :width="'auto'">
                      <i v-if="row[col.value_to_evaluate] == col.value" :class="col.icon_if_value_true"></i>
                    </Tooltip>
                    <i v-show="!col.withTooltip" v-if="row[col.value_to_evaluate] == col.value" :class="col.icon_if_value_true"></i>
                  </span>
                  <span v-else class="text-primary font-weight-bold h6">
                    {{ row[col.value_to_evaluate] }}
                  </span>
                </span>
              </template>

              <!-- type: targetsList -->
              <template v-if="col.type == 'targetsList'">
                <div class="d-flex flex-column">
                  <div
                    v-if="showTargetsExternalControls && (getValue(row, col) || []).length > 0"
                    class="d-flex align-items-center justify-content-end mb-1"
                    @click.stop
                  >
                    <input
                      type="checkbox"
                      :checked="isRowTargetsSelected(row)"
                      :disabled="batchProcessing"
                      @change="toggleRowTargetsSelection(row)"
                    />
                    <small class="ml-1 text-dark font-weight-bold">Select</small>
                  </div>
                  <div v-for="(order, i) in (getValue(row, col) || [])" :key="i" class="d-flex align-items-center mb-1">
                  
                    <span v-if="order.should_call == '0'" class="mr-2"><i class="icon icon-phone bg-danger rounded-circle p-1"></i></span>
                    <span v-if="order.loading" class="spinner-border text-light" role="status"
                      style="width: 1.5rem; height: 1.5rem;"></span>
                    <span v-if="!order.hide" class="badge text-white mb-1 px-3 py-1 rounded-pill"
                      :class="getColorFinished(order)"
                      @click="order.target_id && $emit('goToTarget', order.target_id)" style="cursor: pointer;">
                      {{ order.label }}
                    </span>
                    <button :disabled="order_loading_tasks" class="m-1 btn btn-primary btn-sm" @click="generateTasks(order.target_id)">
                      <span v-if="order_loading_tasks_order[order.target_id]" class="ml-2 spinner-border spinner-border-sm"
                        role="status" aria-hidden="true">
                      </span>
                      + 100 Tasks</button>
                    <input 
                      type="checkbox" 
                      :value="order.target_id"
                      v-model="selectedTargets"
                      :disabled="batchProcessing"
                      class="m-1"
                    />
                    
                    <i v-if="!order.hide" @click="confirmRemoveOrder(row.id, order.target_id, order.label)"
                      class="icon-remove text-danger ml-2">
                    </i>
                  </div>
                </div>
                <div>
                  <i @click="$emit('addOrder', row)" class="icon-plus-square text-primary ml-2"></i>
                </div>
              </template>

              <!-- type: checkboxMultiple -->
              <span v-if="col.type == 'checkboxMultiple'">
                <input type="checkbox" v-model="row.checkToAction" />
              </span>

              <!-- type : html -->
              <span :style="col.style" v-if="
                col.type == 'html' &&
                (!col.loading || (col.loading && !fieldsLoading))
              ">
                <span v-html="getValue(row, col)"></span>
              </span>

              <!-- type : claimContactsInformation -->
              <ClaimContactsInformation
                v-if="col.type == 'claimContactsInformation'"
                :data="getValue(row, col)"
                @load-contacts="$emit('loadClaimContactsInformation', $event)"
              />

              <!-- type : campaignsBadge -->
              <span v-if="
                !row[col.tooltip] &&
                col.type == 'campaignsBadge' &&
                (!col.loading || (col.loading && !fieldsLoading))
              ">
                <CampaignsOrder :order="col.formatNumber ? row : null" :orderId="getValue(row, col)" :qty="true" />
              </span>

              <!-- type : targetProblem (lazyLoad: button first, component on click) -->
              <span v-if="
                !row[col.tooltip] &&
                col.type == 'targetProblem' &&
                col.lazyLoad &&
                !isTargetProblemLazyLoaded(getValue(row, col))
              ">
                <button
                  type="button"
                  class="btn btn-sm btn-outline-primary"
                  :title="col.button_title || 'Show contact utilization'"
                  @click.stop="loadTargetProblemLazy(getValue(row, col))"
                >
                  <i :class="col.button_icon || 'icon-eye'"></i>
                  <span v-if="col.button_label" class="ml-1">{{ col.button_label }}</span>
                </button>
              </span>
              <span v-if="
                !row[col.tooltip] &&
                col.type == 'targetProblem' &&
                (!col.lazyLoad || isTargetProblemLazyLoaded(getValue(row, col))) &&
                (!col.loading || (col.loading && !fieldsLoading))
              ">
                <ContactsSituation
                :key="'targetProblem-' + getValue(row, col) + '-' + trkey"
                :target_id="getValue(row, col)"
                :small="col.small !== undefined ? col.small : true"
                @getAvailableContacts="getAvailableContacts" />
              </span>

              <Tooltip :text="row[col.tooltip_value]" :width="'auto'" v-if="row[col.tooltip_value]">
                <i class="d-inline ml-2 cursor-pointer text-secondary ml-2 fa " :class="col.tooltip_icon"></i>
              </Tooltip>

              <!-- type : statsBadge -->
              <span v-if="
                !row[col.tooltip] &&
                col.type == 'statsBadge' &&
                (!col.loading || (col.loading && !fieldsLoading))
              ">
                <StatsOrder
                  :key="'stats-' + getValue(row, col) + '-' + trkey"
                  :orderId="getValue(row, col)"
                  :qty="true"
                  :stats="row"
                />
              </span>

              <!-- type : twoValues -->
              <template v-if="col.type == 'twoValues'">
                <span>
                  {{ getValue(row, col) }}
                </span>

                <span class="mr-2" v-for="icon in col.value2.icons">

                  <template v-if="row[col.value2.value] == icon.icon_if_value">
                    <Tooltip :text="icon.tooltip_true_value === undefined
                      ? icon.tooltip_true
                      : row[icon.tooltip_true_value]
                      " :width="'auto'" v-if="icon.tooltip_true || icon.tooltip_true_value">
                      <i class="d-inline ml-2 cursor-pointer" :class="icon.icon_true"></i>


                    </Tooltip>
                  </template>
                </span>
              </template>

              <!-- type : Icons -->
              <template v-if="col.type == 'icon'">
                <template v-if="row.totalRow"> 
                  <span class="text-primary font-weight-bold h6">
                  {{ getValue(row, col) }}
                </span>
                </template>
                <template v-else>
                  <span v-if="getValue(row, col) == col.icon_if_value">
                    <i :class="col.icon_true"></i>
                  </span>
                </template>
              </template> 

              <!-- type : setIcons -->
              <template v-if="col.type == 'setIcons'">
                  <template v-for="(item) in (getValue(row, col) || [])">
                    <template v-for="(icon, j) in col.setIcons">
                      <span class="mx-2" v-if="icon.icon_if_value == item.state">
                        <Tooltip :text="icon.toolTipText + ' / ' + item.date" :width="'auto'">
                          <i :class="icon.icon_true"></i>
                        </Tooltip>
                      </span>
                  </template>                  
                </template>
              </template>              

              <!-- type : setIconsString -->
              <template v-if="col.type == 'setIconsString'">

                <template v-for="(icon, j) in col.setIcons">
                  <!-- <template v-for="(item) in getValue(row, col)">                                  -->

                  <span class="mx-2" v-if="icon.icon_if_value == getValue(row, col)">
                    <Tooltip :text="icon.toolTipText" :width="'auto'">
                      <i :class="icon.icon_true"></i>
                    </Tooltip>
                  </span>
                  <!-- </template> -->
                </template>
                <!-- <template v-for="(icon) in col.setIcons">
                  <template v-for="(item) in getValue(row, col).split(',')">                  
                    <span class="mx-2" v-if="icon.icon_if_value == item">
                        <Tooltip :text="icon.toolTipText" :width="'auto'">
                          <i :class="icon.icon_true"></i>                           
                        </Tooltip>
                    </span>
                  </template>  
                </template> -->
              </template>

              <!-- type : btnIfNotNull -->
              <template v-if="col.type == 'btnIfNotNull'">
                <span v-if="!col.format">
                  <button 
                  class="btn btn-sm w-40"
                  :class="col.loading_data && col.loading_data.includes(row[col.btnId])
                      ? 'btn-secondary btn-loading'
                      : 'btn-primary themed-button effect-btn'"
                  v-if="row[col.value_if] != null"
                  :disabled="col.loading_data && col.loading_data.includes(row[col.btnId])"
                  @click="$emit(col.emit, row[col.btnId])"
                  >
                    <span class="text-center"> {{ col.name }}</span>
                  </button>
                </span>
                <span v-if="col.format == 1">
                  <span v-if="row[col.value] != null && row[col.value] != ''">{{ col.label }}</span>
                  <span v-else>{{ col.default }}</span>
                </span>
                <span v-if="col.format == 2">
                  <span :class="row[col.value2] != 'Invalid' ? 'font-weight-bold badge badge-success' : 'font-weight-bold badge badge-danger'" v-if="row[col.value1] == ''">{{ row[col.value2] != 'Invalid' ? 'valid': row[col.value2] }}</span>
                  <span class="font-weight-bold badge badge-danger" v-else>{{ col.value1 }}</span>
                </span>
                <span v-if="col.format == 3">
                  <button
                    v-if="row[col.value_if] == (col.value_equals != null ? col.value_equals : col.value)"
                    :class="col.class || 'btn btn-primary btn-sm themed-button effect-btn w-40'"
                    @click="$emit(col.emit, row[col.value_emit || col.btnId])"
                  >
                    <i v-if="col.icon" :class="col.icon" class="mr-1"></i>
                    <span class="text-center">{{ col.label || col.name }}</span>
                  </button>
                </span>
                <span v-if="col.format == 4">
                  <button 
                  class="btn btn-primary btn-sm themed-button effect-btn w-40" 
                  v-if="row[col.value_if] == 'sepa'" 
                  @click="$emit(col.emit, row[col.btnId])"
                  >
                    <span class="text-center"> {{ col.name }}</span>
                  </button>
                </span>
              </template>

              <!-- type : commentIcon -->
              <template v-if="col.type == 'commentIcon'">
                <button
                  type="button"
                  class="btn btn-link p-0 border-0 align-middle"
                  :class="{ 'comment-icon-warning': row.time_warning == '1' || row.time_warning === 1 }"
                  @click="$emit(col.emit || 'openComments', row[col.value_emit || col.value || 'id'])"
                >
                  <img src="@/assets/images/comment.png" alt="comment" width="16" height="16" />
                </button>
              </template>

              <!-- type : btnAction -->
              <div class="w-100" v-if="col.type == 'btnAction' && (!col.visible_value || row[col.visible_value])">
                <button class="btn btn-primary btn-sm themed-button effect-btn w-40"
                  :disabled="col.disabled.includes(row[col.value])" @click="$emit(col.emit, row[col.btnId])">
                  <span :class="!col.loading_data.includes(row[col.value])
                      ? 'px-3'
                      : 'px-1'
                    ">{{ row[col.name] }}</span>
                  <span v-if="col.loading_data.includes(row[col.value])" class="ml-2 spinner-border spinner-border-sm"
                    role="status" aria-hidden="true">
                  </span>
                </button>
                <i v-if="row.action_ok == 'yes'" aria-checked="false" class="icon-checkmark text-success mr-2 ml-2"></i>
                <Tooltip
                  v-if="col.tag_value && row[col.tag_value]"
                  :text="col.tag_tooltip_value ? (row[col.tag_tooltip_value] || '') : ''"
                  :width="'300px'"
                >
                  <span :class="['badge ml-2',
                    row[col.tag_value] === 'Valid'   ? 'badge-success' :
                    row[col.tag_value] === 'Invalid' ? 'badge-danger' :
                    'badge-warning'
                  ]">{{ row[col.tag_value] }}</span>
                </Tooltip>
              </div>

              <!-- type : btnFieldAction -->
              <div class="w-100" v-if="col.type == 'btnFieldAction'">
                <input class="form-text-input mr-2" type="text" value="" :id="'inputField-' + row.id"
                  v-model="inputField[row[col.btnId]]" @change="change123(row[col.btnId])" />
                <button class="btn btn-primary btn-sm themed-button effect-btn w-40"
                  :disabled="col.disabled.includes(row[col.value])" @click="$emit(col.emit, row[col.btnId])">
                  <span :class="!col.loading_data.includes(row[col.value])
                      ? 'px-3'
                      : 'px-1'
                    ">{{ col.name }}</span>
                  <span v-if="col.loading_data.includes(row[col.value])" class="ml-2 spinner-border spinner-border-sm"
                    role="status" aria-hidden="true">
                  </span>
                </button>
                <i v-if="row.action_ok == 'yes'" aria-checked="false" class="icon-checkmark text-success mr-2 ml-2"></i>
              </div>

              <!-- type : isComponentAsync -->
              <template v-if="col.type === 'isComponentAsync'">

                <div v-if="getValue(row, col) == 'empty'" class="spinner-border text-primary" role="status"
                  style="width: 1rem; height: 1rem;">
                </div>
                <div v-else>
                  <ClientsToBooker :data="getValue(row, col)" />                  
                </div>
              </template>


              <!-- type : isAsync -->
              <template v-if="col.type === 'isAsync'">
                <div v-if="getValue(row, col) == 'empty'" class="spinner-border text-primary" role="status"
                  style="width: 1rem; height: 1rem;"></div>

                <div v-else class="d-inline disabled">

                  <template v-if="typeof getValue(row, col) === 'string'">
                    <span v-if="getValue(row, col) != 'empty'">
                      {{ getValue(row, col) }}
                    </span>
                    <span class="ml-1" v-if="getValue(row, col) != 'empty' && col.format == 'percentage'">
                      %
                    </span>
                  </template>

                  <template v-else>

                    <template v-if="typeof getValue(row, col) === 'number'">

                      <span v-if="getValue(row, col) != 'empty'">
                        {{ getValue(row, col) }}
                      </span>

                    </template>

                    <template v-else>
                      <!-- <span v-if="getValue(row, col) != 'empty' &&  getValue(row, col) > 0"></span> -->
                      <span v-if="getValue(row, col) != 'empty'">
                        {{ getValue(row, col) }}
                      </span>

                      <span
                        v-if="getValue(row, col) != 'empty' && getValue(row, col) > 0 && col.format == 'percentage'">
                        %
                      </span>
                    </template>
                  </template>
                </div>
              </template>

              <!-- type : peopleNames -->
              <template v-if="
                col.type === 'peopleNames' && getValue(row, col) && Array.isArray(getValue(row, col)) && getValue(row, col).length > 0
              ">
                <div class="d-inline disabled" v-for="(item, i) in getValue(row, col)" :key="i">
                  <Tooltip :text="item" :width="'auto'">
                    <i class="d-inline ml-2 icon-user"></i>
                  </Tooltip>
                </div>
              </template>

              <!-- type : listBadges -->
              <template v-if="
                col.type === 'listBadges' && getValue(row, col) && Array.isArray(getValue(row, col)) && getValue(row, col).length > 0
              ">
                <div class="d-inline disabled" v-for="(item, i) in getValue(row, col)" :key="i">
                  <!-- <span v-html="getIcon(item.icon)"></span> -->
                  <!-- {{ getIcon(item.icon)}} -->
                  <Tooltip :text="item.tooltip" :width="'auto'">
                    <span class="d-inline" v-if="item.value">
                      <img v-if="item.icon" class="ml-1" :src="require('@/assets/images/' + item.icon)" alt="" srcset=""
                        width="18px" />
                      <span class="mx-2">
                        {{ item.value ? item.value : "___" }}
                      </span>
                    </span>
                  </Tooltip>
                </div>
              </template>

              <!-- type : status -->
              <template v-if="col.type === 'status'">
                <span v-if="row[col.value] == '1' && col.icon_to_true != null">
                  <i :class="col.icon_to_true"></i>
                </span>
                <span v-if="row[col.value] == '0' && col.icon_to_false != null">
                  <i :class="col.icon_to_false"></i>
                </span>
              </template>

              <!-- type :  ImageSet -->
              <template
                v-if="col.type == 'imageSet' && currentUser && currentUser.role_id !== 4 && currentUser.role_id !== '4'">
                <ImageSet v-if="col.from == 'target'" :target_id="row[col.value]" />
                <ImageSet v-else :client_id="row[col.value]" />
              </template>

              <!-- type :  imageSetMultipleLines -->
              <template
                v-if="col.type == 'imageSetMultipleLines' && currentUser && currentUser.role_id !== 4 && currentUser.role_id !== '4'">
                <ImageSetMultipleLines
                  v-if="col.from == 'target'"
                  :target_id="row[col.value]"
                  :client_priority="row[col.client_priority_value]"
                />
                <ImageSetMultipleLines
                  v-else
                  :client_id="row[col.value]"
                  :client_priority="row[col.client_priority_value]"
                />
              </template>



              <!-- type :  ImageSetClients -->
              <template v-if="col.type == 'imageSetClients'">
                <ImageSetClients :user_id="row[col.value]" />
              </template>

              <!-- type :  Image -->
              <template v-if="col.type == 'image'">
                <template v-if="col.hasTooltip">
                  <Tooltip :text="row[col.hasTooltip]">

                    <img v-if="col.isStatic" :src="flagActually(row[col.value])" alt="" srcset=""
                      :width="col.width ? col.width : '22px'" />

                    <img v-else class="rounded-circle" :src="row[col.value]" alt="" srcset=""
                      :width="col.width ? col.width : '28px'" />



                  </Tooltip>
                </template>

                <template v-else>
                  <img class="rounded-circle" :src="row[col.value]" alt="" srcset=""
                    :width="col.width ? col.width : '28px'" />
                </template>

                <!-- image for provider prospectors -->
                <template v-if="!col.hasTooltip && col.ImageWithIf">
                  <div v-if="row[col.value] == 'ews'">
                    <img class="rounded-circle" :src="require('@/assets/images/outlook.png')" width="20" height="15" />
                  </div>
                  <div v-if="row[col.value] == 'gmail'">
                    <img class="rounded-circle" :src="require('@/assets/images/gmail.png')" width="20" height="15" />
                  </div>
                </template>
              </template>

              <!-- type :  ImageBadge -->
              <template v-if="col.type == 'ImageBadge'">
                <img class="rounded-circle p-0 m-0" :src="require('@/assets/images/revene_ranking/mini/' +
                  row[col.value])
                  " width="58px" />
              </template>

              <!-- type :  itemBadgeConditional -->
              <template v-if="col.type == 'itemBadgeConditional'">

                <span v-if="col.format == 'genericConditional' && !row.totalRow">
                  <span v-if="col.typeConditional == 'equal'">
                    <span v-if="row[col.fieldCondition] == true" :class="col.classStyle">
                      {{ row[col.value] }}
                    </span>
                    <span v-else>
                      {{ row[col.value] }}
                    </span>
                  </span>
                </span>

                <span v-if="col.format == 'score'">
                  <span class="font-weight-bold" :class="row[col.min] == 1 ? 'text-danger' : row[col.min] == 4 ? 'text-warning' : 'text-success'">{{ row[col.value] }}</span>
                </span>

                <span v-if="col.format != 'score' && col.format != 'genericConditional'">
                  <div v-if="getValue(row, col) == 'empty' && !row.totalRow" class="spinner-border text-primary" role="status"
                    style="width: 1rem; height: 1rem;"></div>
                  <span v-else-if="row.totalRow" class="text-primary font-weight-bold h6">
                    {{ row[col.value] }}
                    <span v-if="
                      getValue(row, col) &&
                      col.format &&
                      col.format == 'percentage'
                    ">
                      %
                    </span>
                  </span>
                  <span v-else :class="row[col.value3] == true
                      ? 'badge font-weight-normal text-dark'
                      : (row[col.min] != undefined && (row[col.value] > row[col.min] || row[col.min] == 0)) ||
                        (row[col.max] != undefined && row[col.value] < row[col.max])
                        ? ''
                        : 'badge badge-danger font-weight-normal'
                    "
                    :style="row[col.value3] == true ? 'background-color: #9ADD08; font-weight: normal; font-size: 1em;'  : 'font-size: 1em;'"
                    >
                    <span v-if="col.canBeHidden == 'yes' && row.show && row.show == 'no'">
                      * * *
                    </span> 
                    <span v-else>
                      {{ row[col.value] }}
                    </span>
                    
                    <span v-if="
                      getValue(row, col) &&
                      col.format &&
                      col.format == 'percentage'
                    ">
                      %
                    </span>
                  </span>
                </span>

              </template>

              <!-- type :  itemBadge -->
              <template v-if="col.type == 'itemBadge'">

                <span v-if="row.totalRow" class="text-primary font-weight-bold h6">
                  {{ row[col.value] }}
                  <span v-if="
                    getValue(row, col) &&
                    col.format &&
                    col.format == 'percentage'
                  ">
                    %
                  </span>
                </span>

                <Tooltip
                  v-if="row[col.value] != 'empty' && !col.format && !col.role && shouldDisplayItemBadge(row, col) && getBadgeTooltip(row, col)"
                  :text="getBadgeTooltip(row, col)"
                  :width="'auto'"
                >
                  <span
                    @click="(col.emit) ? $emit(col.emit, row.id) : null"
                    :style="'border-radius: 5px; padding: 1px 4px; background-color:' +
                    bgColor(getValue(row, col), col) +
                    '; color:' +
                    textColor(getValue(row, col), col) +
                    '; font-size:' +
                    fontSize(getValue(row, col), col)
                    " v-html="getHtmlContent(row, col)"></span>
                </Tooltip>
                <span v-else-if="row[col.value] != 'empty' && !col.format && !col.role && shouldDisplayItemBadge(row, col)" 
                  @click="(col.emit) ? $emit(col.emit, row.id) : null"
                  :style="'border-radius: 5px; padding: 1px 4px; background-color:' +
                  bgColor(getValue(row, col), col) +
                  '; color:' +
                  textColor(getValue(row, col), col) +
                  '; font-size:' +
                  fontSize(getValue(row, col), col)
                  " v-html="getHtmlContent(row, col)"></span>

                <span v-if="col.format == 'fake' && !row.totalRow">
                  <span v-if="col.role && row[col.role] == 1">
                    <span v-if="row[col.value] && row[col.value3]" class="ml-3" :style="'border-radius: 5px; padding: 1px 4px; background-color:' +
                    bgColor(getValue(row, col), col) +
                    '; color:' +
                    textColor(getValue(row, col), col) +
                    '; font-size:' +
                    fontSize(getValue(row, col), col)
                    ">        
                      {{ row[col.value3] }}          
                      <span class="ml-1" :style="'border-radius: 5px; background-color:' +
                      bgColor(getValue(row, col), col) +
                      '; color:' +
                      textColor(getValue(row, col), col) +
                      '; font-size:' +
                      fontSize(getValue(row, col), col)
                      " v-html="getHtmlContent(row, col)">
                      </span>
                    </span>
                  </span>
                </span>

                <span v-if="col.format == 'bonus' && !row.totalRow">
                  <span v-if="row[col.value2] == true">
                    <span class="bg text-white text-center" style="border-radius: 5px; padding: 1px 5px; background-color: indigo;">
                      {{ row[col.value] }}
                    </span>
                  </span>
                  <span v-else class="font-weight-bold">
                    {{ row[col.value] }}
                  </span>
                </span>
              </template>

              <!-- type : badgeBookingSignal -->
              <template v-if="col.type == 'badgeBookingSignal'">
                <span v-if="!row[col.value]" class="text-muted">—</span>
                <Tooltip
                  v-else
                  :text="row[col.tooltipField || 'booking_signal_tooltip'] || ''"
                  :width="'auto'"
                >
                  <span
                    class="booking-signal-badge"
                    :style="{
                      backgroundColor: bookingSignalBgColor(row[col.value]),
                      color: '#fff',
                    }"
                  >
                    {{ row[col.labelField || 'booking_signal_badge_label'] }}
                  </span>
                </Tooltip>
              </template>

              <!-- type :  Image-icon -->
              <template v-if="col.type == 'image-icon'">
                <img class="" :src="imageIcon(row[col.value])" alt="" srcset="" width="24px" />
              </template>

              <!-- type :  progressStatus -->
              <div class="w-100 p-0 m-0" v-if="col.type == 'progressStatus' && !row.totalRow">
                <ProgressStatus :total="row[col.total]" :progress="row[col.progress]" />
              </div>

              <!-- type : clientActivity -->
              <span v-if="
                !row[col.tooltip] &&
                col.type == 'clientActivity' &&
                (!col.loading || (col.loading && !fieldsLoading))
              ">
                <ClientActivity :clientId="getValue(row, col)" />
              </span>

              <span v-if="col.loading && fieldsLoading"
                class="loadingres mr-1 ml-1 spinner-border loading-spinner text-primary">
              </span>

              <!-- type : map -->
              <span v-if="col.type == 'map'">
                <img class="float-right cursor-pointer" :src="'https://maps.googleapis.com/maps/api/staticmap?center=' +
                  row.location[0] +
                  '&zoom=9&key=' +
                  col.apikey +
                  '&size=150x50&maptype=map&sensor=false&path=color%3ablue|weight:2|fillcolor%3ablue|' +
                  getlocations2(row.location) +
                  '&cache=' +
                  row.id
                  " />
              </span>

              <!-- type : link -->
              <span class="mr-2 overflowhide text-primary cursor-pointer" v-if="
                col.type == 'link' &&
                col.value_if == getValue(row, col) &&
                getValue(row, col)
              ">
                <span v-if="col.canBeHidden == 'yes' && row.show && row.show == 'no'">
                    * * *
                </span> 
                <span v-else>
                  <a :href="'https://google.com/search?q=' +
                    row[col.value_true] +
                    '+' +
                    row['city']
                    " target="blank">
                    <i class="d-inline ml-2 icon-location"></i>
                    {{ row[col.value_true] }}</a></span>
              </span>

              <!-- value : opportunities -->
              <span class="overflowhide" v-if="col.value == 'opportunities'">
                <ContactOpportunities :bcid="row.id" :campaignid="campaignid">
                </ContactOpportunities>
              </span>

              <!-- value : contact_name -->
              <div v-if="
                col.value == 'contact_name' &&
                !row['bounced'] &&
                permissionFront()
              ">
                <ContactStatus :bcid="row.id" :campaignid="campaignid">
                </ContactStatus>
              </div>

              <!-- type : router -->
              <span v-if="col.type == 'router'" :class="col.class">
                <router-link :to="col.url + getValue(row, col)">
                  <span>
                    <i v-if="col.icon != undefined" :class="col.icon"></i>
                    <span v-if="col.label != undefined">{{ col.label }}</span>
                    <span v-else-if="col.value_label != undefined">{{
                      row[col.value_label]
                    }}</span>
                  </span>
                </router-link>
              </span>

              <!-- type : emitConditional -->
              <span v-if="col.type == 'emitConditional' && row[col.value_label]"
                :class="col.class"
                @click="emitnow(col, row[col.value_emit], trkey)">
                {{ row[col.value_label]  }}
              </span>
              
              <!-- type : email -->
              <span v-if="
                col.type == 'emit' &&
                ((col.value_if !== undefined &&
                  col.value_if == 'null' &&
                  !row[col.value]) ||
                  col.value_if == row[col.value] ||
                  (col.value_multiple_if !== undefined &&
                    evalIf(row, col.value_multiple_if)))
              " :class="col.class" @click="emitnow(col, row[col.value_emit], trkey)">
                <i v-if="col.icon != undefined" :class="col.icon"></i>
                <span v-if="col.label != undefined" :title="col.textShort && col.label.length > col.textShort
                    ? col.label
                    : ''
                  ">
                  {{
                    col.textShort
                      ? formatLabel(col.label, col.textShort)
                      : col.label
                  }}
                </span>
                <span v-else-if="col.value_label != undefined" :title="col.textShort && row[col.value_label].length > col.textShort
                    ? row[col.value_label]
                    : ''
                  ">
                  {{
                    col.textShort
                      ? formatLabel(row[col.value_label], col.textShort)
                      : row[col.value_label]
                  }}
                </span>
              </span>
            <!-- </template> -->

              <span class="small" v-if="row[col.qty_value] > 0">
                ({{ row[col.qty_value] }})
              </span>

              <!-- type : qty -->
              <span v-if="col.type == 'qty'" :class="row[col.value] < col.min && col.class_danger">
                {{ row[col.value] }}
              </span>
              <!-- type : email -->
              <span v-if="col.type == 'email'">
                <Email v-if="col.type == 'email'" :email="getValue(row, col)" :model="data" :lockemails="emailLock()"
                  :rowkey="trkey" :status="row['business_contact_status_id']"
                  :status_email="row['business_contact_status_email']" :id="row.id">
                </Email>
              </span>

              <!-- type : time -->
              <span v-if="col.type == 'time'" class="badge" :class="taskOpenHoursClass(row[col.value])">
                {{ row[col.value] }}
                {{ col.type_format == undefined ? "h" : col.type_format }}
              </span>

              <!-- type : progressbar -->
              <div v-if="col.type == 'progressbar' && row[col.total] > 0">
                <div class="progress w100p">
                  <template v-for="(value, keyP) in col.values.filter(
                    el => el.total != 'setting'
                  )">
                    <div :key="key + keyP" class="progress-bar" :class="'bg-' + value.class" role="progressbar" :style="'width: ' +
                      calcPorcentage(row, col.total, value.total) +
                      '%'
                      " :title="col.tooltip"></div>
                  </template>
                </div>
                <div class="mt-3">
                  <template v-for="(value, keyP) in col.values">
                    <div :key="key + keyP + 'icon'" v-if="row[value.total] > 0">
                      <span class="icon-circle-o" :class="'text-' + value.class"></span>
                      {{ value.label }}
                    </div>
                  </template>

                  <template>
                    <div v-if="!col.values.some(value => row[value.total] > 0)">
                      <template v-for="(value, keyP) in col.values.filter(
                        el => el.total === 'setting'
                      )">
                        <div :key="key + keyP + 'icon'">
                          <span class="icon-circle-o" :class="'text-' + value.class"></span>
                          {{ value.label }}
                        </div>
                      </template>
                    </div>
                  </template>
                </div>
              </div>

              <!-- type : percentage -->
              <span v-if="col.type == 'percentage'">
                {{ convertToPercentage(row[col.value]) }}
              </span>
              <!-- type : Bubble -->
              <span v-if="col.type == 'bubble' && col.value_label!==undefined && evaluateCondition(col, row)" @click="handleType2(col, row)">
                <span class="ml-1 p-0   text-center text-white" :class="col.class">{{ col.value_label }}</span>
              </span>
              <span v-if="col.type == 'bubble' && col.value_label==undefined && evaluateCondition(col, row)" @click="handleType2(col, row)">
                <span class="ml-1 p-0 circle  text-center text-white" :class="col.class">{{ row[col.value_if] }}</span>
              </span>

              <span v-if="col.type == 'icon' && row[col.value_if] === col.value" @click="handleType2(col, row)">
                <i :class="col.class"></i>
              </span>

              <!-- type : MULTIPLE -->
              <template v-if="col.type == 'multiple'">

              <!-- <div v-if="col.type == 'multiple'" class="d-flex align-items-center"> -->
                <span v-for="(element, index) in col.conditions" :key="index">
                  <span 
                    v-if="element.type == 'button' && row[element.value_if] == element.value"
                    class="btn btn-sm btn-primary" 
                    @click="handleType2(element, row)"
                  >
                    <span class="text-center"> {{ element.name }}</span>
                  </span>                  

                  <span v-if="element.type == 'audio'">
                    <template
                        v-if="row[element.value_source_type] === 'elevenlabs' && row[element.value_conversation_id]"
                      >
                      <audio
                        :id="'audio-' + row[element.value_conversation_id]"
                        controls
                        src="data:audio/wav;base64,UklGRiQAAABXQVZFZm10IBAAAAABAAEAESsAACJWAAACABAAZGF0YQAAAAA="
                        style="width: 300px; height: 20px;"
                        @play="onElevenLabsPlay(row[element.value_conversation_id], $event)"
                      ></audio>
                    </template>
                    
                    <!-- Caso actual (Ringover / URL directa): se queda igual -->
                    <template v-else>
                      <audio
                        ref="audio"
                        v-if="row[element.value_audio]"
                        :src="row[element.value_audio]"
                        style="width: 300px; height: 20px;"
                        controls
                      ></audio>
                    </template>
                    <!-- <span>
                      <audio 
                        ref="audio" 
                        v-if="row[element.value_audio]" 
                        :src="row[element.value_audio]" 
                        style="width: 300px; height: 20px;"                        
                        controls></audio>
                    </span> -->
                  </span>   

                  <span v-if="
                    element.type == 'icon' &&
                    row[element.value_if] == element.value
                  " @click="handleType2(element, row)">
                    <i :class="element.class"></i> 
                  </span>

                  <span v-if="element.type == 'bubble' && row[element.value_if]" @click="handleType2(element, row)">
                    <span class="ml-1 p-0 circle bg-primary text-center text-white" :class="element.class">{{
                      row[element.value]
                      }}</span>
                  </span>

                  <div v-for="(badge, index) in element.badges" v-if="row[badge.badge_if]" :key="index"
                    :class="badge.badge_class" class="ml-2">
                    <!-- {{row[badge.badge_if] + badge.badge_value}} -->
                    <Tooltip :class="badge.class_tooltip" :text="badge.badge_tooltip" :width="'auto'"
                      v-if="badge.badge_value == undefined">
                      <i :class="badge.badge_icon" :v-if="badge.badge_icon">
                      </i>

                      <span>{{ badge.badge_label }}</span>
                    </Tooltip>

                    <Tooltip :class="badge.class_tooltip" :text="badge.badge_tooltip" :width="'auto'" v-if="
                      badge.badge_value != undefined &&
                      row[badge.badge_if] == badge.badge_value
                    ">
                      <i :class="badge.badge_icon" :v-if="badge.badge_icon">
                      </i>
                      <span>{{ badge.badge_label }}</span>
                    </Tooltip>
                  </div>
                </span>
              </template>
              <!-- type : END MULTIPLE -->

              <!-- type : percentage -->
              <span v-if="col.type == 'audio'">
                <audio ref="audio" v-if="row[col.value_audio]" :src="row[col.value_audio]" controls></audio>
              </span>

              <div
                v-for="badge in col.badges"
                v-if="
                  badge.badge_value != undefined
                    ? row[badge.badge_if] == badge.badge_value
                    : !!row[badge.badge_if]
                "
                :class="badge.badge_class"
                class="ml-2"
              >
                <!-- {{row[badge.badge_if] + badge.badge_value}} -->
                <Tooltip :class="badge.class_tooltip" :text="badge.badge_tooltip" :width="'auto'"
                  v-if="badge.badge_value == undefined">
                  <i :class="badge.badge_icon" :v-if="badge.badge_icon"> </i>

                  <span>{{ badge.badge_label }}</span>
                </Tooltip>

                <Tooltip :class="badge.class_tooltip" :text="badge.badge_tooltip" :width="'auto'" v-if="
                  badge.badge_value != undefined &&
                  row[badge.badge_if] == badge.badge_value
                ">
                  <i :class="badge.badge_icon" :v-if="badge.badge_icon"> </i>
                  <span>{{ badge.badge_label }}</span>
                </Tooltip>
              </div>
            </span>
          </td>
        </template>
      </tr>
    </tbody>
  </table>
</template>
<script>
import $ from "jquery";
import Email from "@/components/AccountCreation/Steps/Campaign/search/Email.vue";
import ContactOpportunities from "@/components/AccountCreation/Steps/Campaign/search/ContactOpportunities.vue";
import ContactStatus from "@/components/AccountCreation/Steps/Campaign/search/ContactStatus.vue";
import ContactsSituation from "@/components/Targets/ContactsSituation.vue";

import { mapState } from "vuex";

import Tooltip from "@/components/Common/Tooltip.vue";
import Loadingcircle from "./Loadingcircle.vue";
import LoadingSpinner from "../LoadingSpinner.vue";
import CampaignsOrder from "@/components/Common/CampaignsOrder.vue";
import StatsOrder from "@/components/Common/StatsOrder.vue";
import ClientActivity from "@/components/Common/ClientActivity.vue";
import ProgressStatus from "@/components/Common/ProgressStatus.vue";
import ImageSet from "@/components/Common/ImageSet.vue";
import ImageSetMultipleLines from "@/components/Common/ImageSetMultipleLines.vue";
import ImageSetClients from "@/components/Common/ImageSetClients.vue";
import ClientsToBooker from "@/components/Common/ClientsToBooker.vue";
import ClaimContactsInformation from "@/components/Opportunities/ClaimContactsInformation.vue";
import SalesridgeImportProgressCell from "@/components/Targets/SalesridgeImportProgressCell.vue";
import moment from "moment";
import { targetsService, adminService } from "@/_services";

export default {
  data() {
    return {
      order_loading_tasks: false,
      order_loading_tasks_order: {},
      selectedTargets: [],
      batchProcessing: false,
      batchProgress: 0,
      batchTotal: 0,
      batchResults: [],
      flags: [
        { id: "fr", lang_id: 1, text: "fr.svg" },
        { id: "en", lang_id: 2, text: "us.svg" },
        { id: "es", lang_id: 3, text: "es.svg" },
        { id: "it", lang_id: 4, text: "it.svg" },
        { id: "pt", lang_id: 5, text: "pt.svg" }
      ],
      orderCount: 0,
      ccol: [],
      cdata: [],
      isopen: false,
      title: "ABCDEFGABCDEFGABCDEFGABCDEFGABCDEFGABCDEFG",
      inputField: [],
      targetProblemLazyLoaded: {},
    };
  },

  computed: {
    ...mapState({
      currentUser: state => state.authentication.user
    }),

    flagActually() {
      return id => {
        if (id) {
          const flag = this.flags.find(e => e.lang_id == id).text;
          return require("@/assets/images/flags/" + flag);
        } else {
          if (this.onBoarding.lang != "") {
            const flag = this.flags.find(
              e => e.lang_id == this.onBoarding.language_id
            ).text;
            return require("@/assets/images/flags/" + flag);
          } else {
            return require("@/assets/images/flags/fr.svg");
          }
        }
      };
    },

    formatLabel() {
      return (label, maxText) => {
        const labelModified =
          label.length > 40 ? label.substr(0, maxText) + "..." : label;
        return labelModified;
      };
    },

    imageIcon() {
      return value => {
        return require("@/assets/images/" + value);
      };
    },

    labelValue() {
      return (value, col, row) => {
        if (col.colors.find(el => el.id == value)) {
          return col.colors.find(el => el.id == value).label;
        } else {
          return row ? row : "...";
        }
      };
    },

    bgColor() {
      return (value, col) => {
        if (col.colors.find(el => el.id == value)) {
          return col.colors.find(el => el.id == value).bgColor;
        } else {
          return "black";
        }
      };
    },
    bookingSignalBgColor() {
      return (type) => {
        const map = {
          boost: "#dc3545",
          reduce: "#fd7e14",
          stop: "#343a40",
        };
        return map[type] || "#6c757d";
      };
    },
    textColor() {
      return (value, col) => {
        if (col.colors.find(el => el.id == value)) {
          return col.colors.find(el => el.id == value).textColor;
        } else {
          return "white";
        }
      };
    },
    fontSize() {
      return (value, col) => {
        if (col.colors.find(el => el.id == value)) {
          let element = col.colors.find(el => el.id == value);
          return element.fontSize ? element.fontSize : "12px";
        } else {
          return "12px";
        }
      };
    },
    
    hasAnyTargets() {
      // Buscar en headers regulares
      const hasInHeaders = this.data.some(row => 
        this.headers.some(header => 
          header.type === 'targetsList' && row[header.value] && Array.isArray(row[header.value]) && row[header.value].length > 0
        )
      );
      
      // Buscar en custom columns
      const hasInCustomColumns = this.customColumns && this.data.some(row => 
        this.customColumns.some(customCol => 
          customCol.type === 'targetsList' && row[customCol.value] && Array.isArray(row[customCol.value]) && row[customCol.value].length > 0
        )
      );
      
      return hasInHeaders || hasInCustomColumns;
    }
  },
  components: {
    Tooltip,
    Email,
    ContactOpportunities,
    ContactStatus,
    Loadingcircle,
    LoadingSpinner,
    CampaignsOrder,
    ClientActivity,
    StatsOrder,
    ContactsSituation,
    ProgressStatus,
    ImageSet,
    ImageSetClients,
    ImageSetMultipleLines,
    ClientsToBooker,
    ClaimContactsInformation,
    SalesridgeImportProgressCell,
  },
  props: {
    fromContacts: {
      type: Boolean,
      required: false,
      default: false
    },
    notselect: {
      type: Boolean,
      required: false,
      default: false
    },
    allpageselected: {
      type: Boolean,
      required: false,
      default: false
    },
    allselected: {
      type: Boolean,
      required: false,
      default: false
    },
    customColumns: {
      type: Array,
      required: false
    },
    checkbox: {
      type: Boolean,
      required: false,
      default: false
    },
    headers: {
      type: Array,
      required: true
    },
    cols: {
      type: Array,
      required: true
    },
    model: {
      type: [Object, Array],
      default: () => ({
        imported: false,
        refreshlist: false,
        selectfirst: false
      })
    },
    campaignid: String,
    data: {
      type: Array,
      required: true
    },
    sizes: {
      type: Array,
      required: false,
      default: () => {
        [];
      }
    },
    myvalues: {
      type: Array,
      required: false
    },
    fieldsLoading: {
      type: Boolean,
      default: false
    },
    showTargetsExternalControls: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  created() {
    if (this.customColumns) {
      let ccol = [];
      this.customColumns.forEach(element => {
        if (element) this.ccol.push(element.label);
      });
    }

    if (this.model.selectedIds == undefined) this.model.selectedIds = [];
    if (this.model.excludedIds == undefined) this.model.excludedIds = [];
  },
  beforeDestroy() {
    document.querySelectorAll('audio[id^="audio-"]').forEach(el => {
      if (el.src && el.src.startsWith('blob:')) {
        URL.revokeObjectURL(el.src);
      }
    });
  },
  methods: {
    isInvoiceCardChargeable(row, col) {
      if (row.card_chargeable !== undefined && row.card_chargeable !== null && row.card_chargeable !== '') {
        return Number(row.card_chargeable) === 1 || row.card_chargeable === true || row.card_chargeable === '1';
      }
      const statusId = Number(row[col.value1]);
      return row[col.value2] == '1' && [1, 3, 6].includes(statusId);
    },
    invoiceCollectTitle(row, col) {
      if (this.isInvoiceCardChargeable(row, col)) {
        return 'Collect';
      }
      if (Number(row.payment_status_id) === 7 || Number(row[col.value1]) === 7) {
        return 'Paiement en cours';
      }
      const messages = {
        judicial_recovery: 'Voie judiciaire : prélèvement bloqué (Ruby).',
        ruby_dossier_active: 'Dossier Ruby Payeur actif : prélèvement bloqué.',
        ruby_closed: 'Dossier Ruby recouvré ou clôturé.',
        amiable_partial: 'Accord amiable partiel : ne pas prélever le total.',
        not_credit_card: "Pas de carte bancaire sur cette facture.",
        wrong_status: 'Cette facture ne peut pas être prélevée.',
      };
      return messages[row.card_charge_block_reason] || 'Collect';
    },
    async onElevenLabsPlay(conversationId, ev) {
      const audioEl = ev.target;
      if (audioEl.dataset.loaded === '1') return; // ya se cargó, dejá que reproduzca
      ev.preventDefault();
      audioEl.pause();
      const blob = await adminService.getElevenLabsAudio(conversationId);
      audioEl.src = URL.createObjectURL(blob);
      audioEl.dataset.loaded = '1';
      audioEl.play();
    },
    async loadAndPlayElevenLabsAudio(conversationId) {
      if (!conversationId) return;
      const audioEl = document.getElementById('audio-' + conversationId);
      if (!audioEl) return;

      if (audioEl.src) {
        audioEl.play();
        return;
      }

      try {
        const blob = await adminService.getElevenLabsAudio(conversationId);
        const blobUrl = URL.createObjectURL(blob);
        audioEl.src = blobUrl;
        audioEl.play();
      } catch (error) {
        console.error('Error cargando audio ElevenLabs:', error);
      }
    },
    getClassStatusMeeting(link_status_reason_id, amount, real_event_date, billing_status) {
      if (link_status_reason_id == 35) {
        return "badge badge-warning";
      }
      if (link_status_reason_id == 34) {
        return "badge badge-danger";
      }
      if (amount == undefined) {
        return "badge badge-secondary";
      }
      if(billing_status == 'next_pay'){
        return "icon-dollar text-secondary";
      }
      if(billing_status == 'pay_declined'){
        return "icon-dollar text-danger";
      }
      if(billing_status == 'pay_pending'){
        return "icon-dollar text-warning";
      }
      if(billing_status == 'future_meeting'){
        return "icon-calendar text-success";
      }
      if (billing_status == 'pay_paid') {
        return "icon-dollar text-success";
      }
      return "icon-calendar text-success";
    },

    getTextStatusMeeting(link_status_reason_id, amount) {
      if (link_status_reason_id == 35) {
        return this.$t("lang.refuse.absentlabel");
      }
      if (link_status_reason_id == 34) {
        return this.$t("lang.refuse.refused");
      }
      if (amount == undefined) {
        return this.$t("lang.label.upcoming");
      }
      return "";
    },

    formatDate(fecha) {
      return moment(fecha).format("YYYY-MM-DD");
    },

    getBankTransferDaysElapsed(row, col) {
      const dateVal = row[col.value8];
      if (dateVal == null || dateVal === "") {
        return null;
      }
      const m = moment(dateVal);
      if (!m.isValid()) {
        return null;
      }
      return moment().startOf("day").diff(m.startOf("day"), "days");
    },

    bankTransferDaysSinceDateDisplay(row, col) {
      const days = this.getBankTransferDaysElapsed(row, col);
      if (days === null) {
        return "";
      }
      return Math.max(0, days);
    },

    isBankTransferContractualOverdue(row, col) {
      // Same rule as the cron payment-bank-transfer-overdue.php: NULL / 0 -> 7 days
      const limit = Number(row[col.value9]) || 7;
      const daysElapsed = this.getBankTransferDaysElapsed(row, col);
      if (daysElapsed === null) {
        return false;
      }
      return daysElapsed > limit;
    },


    getAvailableContacts(data){
      this.$emit('getAvailableContacts', data);
    },

    isTargetProblemLazyLoaded(targetId) {
      if (targetId === undefined || targetId === null) {
        return false;
      }
      return !!this.targetProblemLazyLoaded[String(targetId)];
    },

    loadTargetProblemLazy(targetId) {
      if (targetId === undefined || targetId === null) {
        return;
      }
      this.$set(this.targetProblemLazyLoaded, String(targetId), true);
    },

    situationToneCellClass(row, col) {
      if (!col.toneFrom) {
        return "";
      }
      const tone = row[col.toneFrom];
      if (tone === "ok") {
        return "situation-tone--ok";
      }
      if (tone === "warning") {
        return "situation-tone--warning";
      }
      if (tone === "danger") {
        return "situation-tone--danger";
      }
      if (tone === "loading") {
        return "situation-tone--loading";
      }
      return "";
    },

    situationToneTitle(row, col) {
      if (col.toneTitleFrom && row[col.toneTitleFrom]) {
        return row[col.toneTitleFrom];
      }
      if (
        col.toneFrom &&
        row[col.toneFrom] === "danger" &&
        row.salesridge_launch_error_hint
      ) {
        return row.salesridge_launch_error_hint;
      }
      if (col.toneFrom && row[col.toneFrom] === "loading") {
        return "Loading situation…";
      }
      return col.button_title || "Target situation";
    },

    situationToneOverlayClass(row, col) {
      if (!col.toneFrom || !col.toneOverlay) {
        return "";
      }
      const tone = row[col.toneFrom];
      if (tone === "warning") {
        return "situation-tone-badge--warning";
      }
      if (tone === "danger") {
        return "situation-tone-badge--danger";
      }
      return "";
    },

    getBadgeTargetStatus(status) {
      switch (status) {
        case "1":
          return "badge-info";
          break;
        case "3":
          return "badge-secondary";
          break;
        case "4":
          return "badge-success";
          break;
      }
    },
    
    notesByLevel(level){
      if(level >= 1 && level <= 4){
        return 'bg bg-danger text-white text-center';
      }else if(level >= 5 && level <= 7){
        return 'bg bg-warning text-white text-center';
      }else{
        return 'bg bg-success text-white text-center';
      }
    },
    getColorFinished(order){
      if(order.finished == 1 && order.total_tasks == 0) 
        return 'bg-danger';
      else if(order.total_tasks == 0)
        return 'bg-warning';
      return 'bg-success';
    },
    change123(id) {
      console.log(this.inputField);
      this.model.manualTestFields[id] = this.inputField[id];
    },
    getHtmlContent(row, col) {
      if (row[col.value2]) {
        
        if (col.only_value === "true") {
          return (
            this.labelValue(
              this.getValue(row, col),
              col,
              this.getValue(row, col)
            ) +
            " " +
            row[col.value2] 
          );  
        } else {
          return (
          this.labelValue(
            this.getValue(row, col),
            col,
            this.getValue(row, col)
          ) +
          " " +
          "(" +
          row[col.value2] +
          ")"
        );
        }        
      } else {
        let colaux = col.colors.find(el => el.id == this.getValue(row, col));
        if (colaux && colaux.label) {
          return colaux.label;
        }
        return "";
      }
    },
    getIcon(image) {
      return "@/assets/images/icon_agenda.png";
      //return `<img class="rounded-circle" :src="${image}"   alt="" srcset="" width="18px">`
    },
    hasPermissions(perm) {
      return this.$store.getters["authentication/hasPermissions"](perm);
    },
    evalIf(row, value_multiple_if) {
      let result = true;
      value_multiple_if.forEach((v, i) => {
        if (v.condition == "null") {
          if (row[v.value]) {
            result = false;
          }
        } else {
          if (Array.isArray(v.condition)) {
            if (!v.condition.includes(row[v.value])) {
              result = false;
            }
          } else {
            if (v.condition != row[v.value]) {
              result = false;
            }
          }
        }
      });
      return result;
    },
    emailLock() {
      return (
        this.currentUser.role_id == 4 &&
        !["4", "5"].includes(this.currentUser.plan_id)
      );
    },
    hasPermissionColumn(colg) {
      return (
        colg[0] == undefined ||
        colg[0].role_id == undefined ||
        colg[0].role_id == this.currentUser.role_id
      );
    },
    calcPorcentage(row, total, fraction) {
      if (fraction == "setting" && row[total] > 0) {
        //console.log("fraction", fraction, "tota", total);
        return 100;
      }
      if (row[total] == 0 || row[fraction] == 0) {
        return 0;
      }
      return parseInt((row[fraction] / row[total]) * 100);
    },
    orderBy(field, order) {
      let orderby = {
        field: field,
        order: order
      };
      this.$emit("orderBy", orderby);
    },
    isFacebook(domain) {
      if (domain !== null) return domain.includes("facebook");
      else return false;
    },
    permissionFront() {
      return (
        (this.currentUser.team_role_id == undefined ||
          this.currentUser.team_role_id != 3) &&
        this.currentUser.role_id != 4
      );
    },
    emitnow(col, value, index) {
      //console.log(col);
      if (!value) {
        value = index;
      }
      if (col.filter_emit !== undefined) {
        value = col.filter_emit;
      }
      //console.log(value);
      if (col.action !== undefined) {
        this.$emit(col.emit, col.action, value);
      } else {
        this.$emit(col.emit, value);
      }
    },
    getlocations2(loc) {
      loc = JSON.parse(loc);
      loc = loc.join("|");
      loc = loc;
      return loc;
    },
    getSalaries(salaries) {
      if (salaries >= 1 && salaries <= 10) {
        return "1-10";
      }
      if (salaries >= 10 && salaries <= 50) {
        return "10-50";
      }
      if (salaries >= 50 && salaries <= 200) {
        return "50-200";
      }
      if (salaries >= 200 && salaries <= 500) {
        return "200-500";
      }
      if (salaries >= 500 && salaries <= 1000) {
        return "500-1000";
      }
      if (salaries >= 1000 && salaries <= 5000) {
        return "1000-5000";
      }
      if (salaries >= 5000 && salaries <= 10000) {
        return "5000-10000";
      }
      if (salaries >= 10000 && salaries <= 100000) {
        return "10000-100000";
      }

      if (salaries) {
        return "+100000";
      } else return "-";
    },
    gotoLink(type, link) {
      if (type != "link" || link === undefined || !link) {
        return;
      }
      let url = Array.isArray(link) ? link[0] : link;
      if (typeof url !== "string") {
        return;
      }
      url = url.trim();
      if (!url) {
        return;
      }
      if (/^https?:\/\//i.test(url)) {
        window.open(url, "_blank");
        return;
      }
      if (url.startsWith("//")) {
        window.open("https:" + url, "_blank");
        return;
      }
      window.open("https://" + url.replace(/^\/+/, ""), "_blank");
    },
    getValue(row, col, tooltip) {
      let value = col.value;

      if (tooltip) {
        value = col.tooltip;
      }


      if (col.type === "itemBadge") return row[col.value];
      if (col.type === "badgeBookingSignal") {
        return row[col.labelField || "booking_signal_badge_label"] || row[col.value] || "—";
      }
      if (col.type === "status") return row[col.value];
      if (col.type === "listBadges") return Array.isArray(row[col.value]) ? row[col.value] : (row[col.value] ? [row[col.value]] : []);
      if (col.type === "peopleNames") {
        const val = row[col.value];
        return Array.isArray(val) ? val : (val ? [val] : []);
      }
      if (col.type === "targetsList") {
        const val = row[col.value];
        return Array.isArray(val) ? val : [];
      }

      if (col.show_text === "false" && !col.show_total) return "";

      if (col.type == "condition") {
        if (col.value_if == row[col.value]) {
          return col.label;
        }
        return "";
      }

      if (col.getvalue) {
        value = "";
        if (row[col.value]) {
          this.myvalues.forEach(thevalue => {
            if (thevalue.id == row[col.value]) {
              value = thevalue.name;
              return;
            }
          });
        }

        return value;
      }

      if (col.type == "link" && col.value_label && row[col.link]) {
        value = col.value_label;
        return value;
      }

      if (col.filter) {
        value = this.$options.filters[col.filter](row[value]);
        return value;
      }

      if (col.type == "days") {
        let result = [];
        let days = row[value].split(",");
        days.forEach(element => {
          result.push(this.$t("lang.sending_days." + element));
        });
        return result.join(", ");
      }

      if (col.value == "salaries") {
        return this.getSalaries(row[value]);
      }

      if (col.translate !== undefined && col.translate) {
        return this.$t(col.translate + "." + row[value]);
      }

      if (col.value2 !== undefined && row[value]) {
        if (row[value][col.value2]) {
          return row[value][col.value2];
        }
      }

      if(Array.isArray(row[value]) && row[value].length == 0){
         return col.value_empty;
      }

      const raw = row[value];
      if (raw !== undefined && raw !== null && raw !== "") return raw;
      return col.value_empty;
    },
    getBadgeTooltip(row, col) {
      const value = this.getValue(row, col);
      if (row[col.value] == 'empty' || col.format || col.role) return null;
      if (col.colors && Array.isArray(col.colors)) {
        const colorItem = col.colors.find(el => String(el.id) === String(value));
        if (colorItem) {
          if (colorItem.tooltipRowField) {
            const fromRow = row[colorItem.tooltipRowField];
            if (fromRow != null && fromRow !== "") {
              return fromRow;
            }
            if (colorItem.tooltipFallbackKey) return this.$t(colorItem.tooltipFallbackKey);
          }
          if (colorItem.tooltip) return colorItem.tooltip;
        }
      }
      if (col.tooltipWhenValue && col.tooltipText && value == col.tooltipWhenValue) return col.tooltipText;
      return null;
    },
    /**
     * No renderizar badge cuando el valor mapea a un placeholder (p. ej. id 1 transparente sin label)
     * o cuando no hay entrada en colors (evita guión/caja negra vacía). Sigue mostrando totalRow.
     */
    shouldDisplayItemBadge(row, col) {
      if (row.totalRow) return false;
      const raw = row[col.value];
      if (raw === "empty" || raw === null || raw === undefined) return false;
      if (!col.colors || !Array.isArray(col.colors)) return true;
      const entry = col.colors.find((el) => String(el.id) === String(raw));
      if (!entry) return false;
      const bg = (entry.bgColor || "").toLowerCase();
      const noLabel = !entry.label || String(entry.label).trim() === "";
      const transparentBg =
        bg === "transparent" ||
        bg === "rgba(0,0,0,0)" ||
        bg === "rgba(0, 0, 0, 0)";
      if (transparentBg && noLabel) return false;
      return true;
    },
    getContactPreviewValue(row, col, field) {
      // Primero intentar desde organization (si existe y no está vacío)
      if (row[col.value] && !Array.isArray(row[col.value]) && row[col.value][field]) {
        const value = row[col.value][field];
        // Si es un array (como specialties), convertirlo a string
        if (Array.isArray(value)) {
          return value.join(', ');
        }
        return value;
      }
      
      // Si organization está vacío o no existe, buscar en employment.current.company
      if (row.employment && row.employment.current && row.employment.current.company) {
        const company = row.employment.current.company;
        const current = row.employment.current;
        
        // Manejar industry (caso especial por estructura anidada)
        if (field === 'industry') {
          if (company.industry && company.industry.main_industry) {
            return company.industry.main_industry;
          }
          if (company.industry) {
            return typeof company.industry === 'string' ? company.industry : company.industry.main_industry || '';
          }
        }
        
        // Manejar description (puede estar en current o company)
        if (field === 'description') {
          if (current.description) {
            return current.description;
          }
          if (company.description) {
            return company.description;
          }
        }
        
        // Manejar specialties (array en company)
        if (field === 'specialties') {
          if (company.specialties && Array.isArray(company.specialties)) {
            return company.specialties.join(', ');
          }
          if (company.specialties) {
            return typeof company.specialties === 'string' ? company.specialties : '';
          }
        }
        
        // Para cualquier otro campo, intentar acceder directamente
        if (company[field]) {
          const value = company[field];
          if (Array.isArray(value)) {
            return value.join(', ');
          }
          return value;
        }
        
        // También intentar en current para otros campos
        if (current[field]) {
          const value = current[field];
          if (Array.isArray(value)) {
            return value.join(', ');
          }
          return value;
        }
      }
      
      return '';
    },
    getContactPreviewValueAsString(row, col, field) {
      try {
        const value = this.getContactPreviewValue(row, col, field);
        
        // Si es null o undefined, retornar string vacío
        if (value === null || value === undefined) {
          return '';
        }
        
        // Si es un string vacío, retornar string vacío
        if (value === '') {
          return '';
        }
        
        // Si es un string, verificar que tenga contenido
        if (typeof value === 'string') {
          // Si después de trim tiene contenido, retornar el string original
          const trimmed = value.trim();
          return trimmed.length > 0 ? value : '';
        }
        
        // Si es un array, filtrar y unir
        if (Array.isArray(value)) {
          if (value.length === 0) {
            return '';
          }
          const filtered = value.filter(v => {
            if (v === null || v === undefined || v === '') {
              return false;
            }
            const str = String(v).trim();
            return str.length > 0;
          });
          return filtered.length > 0 ? filtered.join(', ') : '';
        }
        
        // Convertir cualquier otro tipo a string
        const str = String(value);
        // Verificar que no sea 'null', 'undefined' o solo espacios
        const trimmedStr = str.trim();
        if (trimmedStr === '' || trimmedStr === 'null' || trimmedStr === 'undefined') {
          return '';
        }
        return str;
      } catch (error) {
        console.error('Error in getContactPreviewValueAsString:', error, { row, col, field });
        return '';
      }
    },
    truncateText(text, maxLength) {
      if (!text) return text;
      // Convertir a string si no lo es
      const textStr = typeof text === 'string' ? text : String(text);
      if (textStr.length <= maxLength) return textStr;
      return textStr.substring(0, maxLength) + '...';
    },
    closeCols() {
      this.isopen = false;
    },
    openCols() {
      this.isopen = true;
    },
    isAllActive() {
      if (this.allselected == true || this.allpageselected == true) {
        return "checked";
      }
    },
    activeAll() {
      this.data.forEach(element => {
         element.selectAllPages = this.model.allselected;
        if (this.model.selectedIds.indexOf(element.id) == -1) {
          this.model.selectedIds.push(element.id);
        }
      });
    },
    deactiveAll() {
      this.model.selectedIds = [];
      this.model.allselected = false;
      this.model.allpageselected = false;
      this.$forceUpdate();
    },
    selectAll() {
      this.model.excludedIds = [];
      this.model.selectedIds = [];
      this.model.allselected = true;
      this.model.allpageselected = false;
      this.$emit('select-all-pages-changed', this.model.allselected);
      this.activeAll();
    },
    selectAllPage() {
      this.model.selectedIds = [];
      this.model.excludedIds = [];
      this.model.allselected = false;
      this.model.allpageselected = true;
      this.$emit('select-all-pages-changed', this.model.allselected);
      this.activeAll();
    },

    getRowValues(indexColumn, indexBusinessContact) {
      let custom_val = this.model.contacts.list[indexBusinessContact]
        .custom_values;
      let custom_cols = this.model.contacts.list[indexBusinessContact]
        .custom_columns;

      if (custom_val == null) {
        custom_cols = [];
        custom_val = [];
        this.customColumns.forEach((element, index) => {
          custom_cols.push(index);
          custom_val.push(" ");
        });
        for (let i = 0; i < custom_cols.length; i++) {
          if (custom_cols[i] == indexColumn) {
            if (custom_val[i]) {
              return custom_val[i];
            } else {
              return false;
            }
          }
        }
      } else {
        if (custom_val !== null) {
          custom_val = custom_val.split(",");
          custom_cols = custom_cols.split(",");
          for (let i = 0; i < custom_cols.length; i++) {
            if (custom_cols[i] == indexColumn) {
              if (custom_val[i]) {
                return custom_val[i];
              } else {
                return false;
              }
            }
          }
        }
      }
      return false;
    },
    isOpenClass(index) {
      if (this.isopen && this.customColumns[index + 1] == undefined) {
        return "opened openedlast";
      }

      if (!this.isopen) {
        return "closed";
      }

      return "opened";
    },
    toggleAllPages() {
      if (this.model.noselectall) {
        this.$swal({
          type: "warning",
          title: this.$t("lang.planfeatures.planbusinesstitle"),
          html: this.$t("lang.planfeatures.planbusiness"),
          showCancelButton: true,
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          confirmButtonText: this.$t("lang.button.contactus"),
          cancelButtonText: this.$t("lang.button.cancel")
        }).then(result => {
          if (result.value == true) {
            window.open("mailto:entreprise@oliverlist.com", "_blank");
            // this.$router.push('/upgrade');
          }
        });
        return;
      }

      if (this.model.allselected == false) {
        this.selectAll();
      } else {
        this.deactiveAll();
      }
      this.$forceUpdate();
      this.$emit("toggleItem");
    },
    toggleAll() {
      if (this.model.allpageselected == false) {
        this.selectAllPage();
      } else {
        this.deactiveAll();
      }
      this.$forceUpdate();
      this.$emit("toggleItem");
    },
    isActive(id) {
      if (this.model.selectedIds && this.model.excludedIds) {
        return (
          this.model.selectedIds.indexOf(id) > -1 &&
          this.model.excludedIds.indexOf(id) == -1
        );
      }
    },
    orderActive(field) {
      let header = this.headers.map(header => {
        if (header.orderby == true && header.field != field) {
          header.orderby = false;
        }
        if (header.field == field) {
          header.orderby = true;
        }
      });
    },
    toggleItem(id, status) {
      if (this.notselect) {
        return;
      }

      this.allpageselected = false;
      if (this.isActive(id)) {
        this.model.selectedIds = this.model.selectedIds.filter(c => c != id);
        this.model.excludedIds.push(id);
      } else {
        this.model.excludedIds = this.model.excludedIds.filter(c => c != id);
        this.model.selectedIds.push(id);
      }
      this.$forceUpdate();
      this.$emit("toggleItem");
      this.$emit("updateModel", this.model);
    },

    handleType2(col, row) {
      if (col.type2 == "emit") {
        let payload = row;
        if (
          col.type === "icon" &&
          col.value_emit != null &&
          row != null &&
          typeof row === "object"
        ) {
          payload = row[col.value_emit];
        }
        this.$emit(col.emit, payload);
      }
      if (col.type == "link") {
        this.gotoLink(col.type, row.link);
      }
    },
  evaluateCondition(col, row) {
    if (!col.condition || !col.value_if) return false;

    try {
      const value = row[col.value_if];
      // Creamos una función dinámica que recibe el valor como parámetro
      const fn = new Function('value', `return ${col.condition.replaceAll(col.value_if, 'value')}`);
      return fn(value);
    } catch (e) {
      console.error('Error evaluando condición:', col.condition, e);
      return false;
    }
  },
    convertToPercentage(value) {
      const numericValue = parseInt(value);
      return `${numericValue * 20}%`;
    },
    taskOpenHoursClass(task_open_hours) {
      if (task_open_hours < 24) {
        return "badge-warning";
      } else if (task_open_hours < 12) {
        return "badge-warning";
      }
      return "badge-danger";
    },
    async generateTasks(targetId) {
      this.order_loading_tasks = true;
      this.order_loading_tasks_order[targetId] = true;
      try {
        if (!targetId) {
          console.error('Target ID is required');
          this.order_loading_tasks = false;
          this.order_loading_tasks_order[targetId] = false;
          return;
        }
        
        const response = await targetsService.createTasks(targetId);
        console.log('Tasks generated successfully:', response);
        this.order_loading_tasks = false;
        
        // Show success modal with detailed results
        this.$swal({
          title: this.$t('lang.taskGeneration.title'),
          html: `
            <div class="text-left">
              <div class="mb-3">
                <h6 class="text-success mb-2">📊 ${this.$t('lang.taskGeneration.summary')}</h6>
                <div class="row">
                  <div class="col-6">
                    <div class="card bg-success text-white mb-2">
                      <div class="card-body p-2">
                        <h5 class="card-title mb-1">${response.tasks_created}</h5>
                        <small>${this.$t('lang.taskGeneration.tasksCreated')}</small>
                      </div>
                    </div>
                  </div>
                  <div class="col-6">
                    <div class="card bg-warning text-white mb-2">
                      <div class="card-body p-2">
                        <h5 class="card-title mb-1">${response.tasks_skipped}</h5>
                        <small>${this.$t('lang.taskGeneration.tasksSkipped')}</small>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              
              <div class="mb-3">
                <h6 class="text-primary mb-2">📈 ${this.$t('lang.taskGeneration.targetStats')}</h6>
                <div class="row">
                  <div class="col-4">
                    <div class="text-center">
                      <h5 class="text-primary mb-1">${response.target_stats.tasks}</h5>
                      <small class="text-muted">${this.$t('lang.taskGeneration.totalTasks')}</small>
                    </div>
                  </div>
                  <div class="col-4">
                    <div class="text-center">
                      <h5 class="text-info mb-1">${response.target_stats.bookers}</h5>
                      <small class="text-muted">${this.$t('lang.taskGeneration.bookers')}</small>
                    </div>
                  </div>
                  <div class="col-4">
                    <div class="text-center">
                      <h5 class="text-warning mb-1">${response.target_stats.tasks_per_booker}</h5>
                      <small class="text-muted">${this.$t('lang.taskGeneration.tasksPerBooker')}</small>
                    </div>
                  </div>
                </div>
              </div>
              
              <div class="mb-2">
                <h6 class="text-secondary mb-2">📞 ${this.$t('lang.taskGeneration.contacts')}</h6>
                <div class="alert alert-info mb-0">
                  <strong>${response.total_contacts}</strong> ${this.$t('lang.taskGeneration.totalContactsProcessed')}
                </div>
              </div>
              
              <div class="mt-3">
                <small class="text-muted">${this.$t('lang.taskGeneration.targetId')}: ${response.target_id}</small>
              </div>
            </div>
          `,
          icon: 'success',
          confirmButtonText: this.$t('lang.taskGeneration.perfect'),
          confirmButtonColor: '#28a745',
          width: '500px',
          customClass: {
            popup: 'swal-wide'
          }
        });
        
        // Emit event to parent component to refresh data
        this.$emit('tasksGenerated', { targetId, response });
        this.order_loading_tasks_order[targetId] = false;
        
      } catch (error) {
        console.error('Error generating tasks:', error);
        this.order_loading_tasks = false;
        this.order_loading_tasks_order[targetId] = false;
        
        // Determine error message
        let errorMessage = this.$t('lang.taskGeneration.noMoreContacts');
        if (error.response && error.response.status === 500) {
          const dataMessage = error.response.data && error.response.data.message;
          if (dataMessage && dataMessage.includes('no more contacts')) {
            errorMessage = this.$t('lang.taskGeneration.noMoreContacts');
          }
        }
        
        // Show error modal
        this.$swal({
          title: this.$t('lang.taskGeneration.errorTitle'),
          text: errorMessage,
          icon: 'error',
          confirmButtonText: this.$t('lang.taskGeneration.understood'),
          confirmButtonColor: '#dc3545'
        });
        
        // Emit error event to parent component
        this.$emit('tasksGenerationError', { targetId, error });
      }
    },
    
    // Batch processing methods
    getAllTargetsInTable() {
      const allTargets = [];
      
      // Check if we have data
      if (!this.data || this.data.length === 0) {
        return allTargets;
      }
      
      this.data.forEach((row, index) => {
        // Check if the row has targets_booker array
        if (row.targets_booker && Array.isArray(row.targets_booker)) {
          row.targets_booker.forEach(target => {
            if (target.target_id) {
              allTargets.push(target);
            }
          });
        }
        
        // Also check if the row itself has target_id (main data structure)
        if (row.target_id) {
          allTargets.push(row);
        }
        
        // Check headers for targetsList type
        this.headers.forEach(header => {
          if (header.type === 'targetsList' && row[header.value]) {
            const orders = row[header.value];
            if (Array.isArray(orders)) {
              orders.forEach(order => {
                allTargets.push(order);
              });
            }
          }
        });
        
        // Also check custom columns
        if (this.customColumns) {
          this.customColumns.forEach(customCol => {
            if (customCol.type === 'targetsList' && row[customCol.value]) {
              const orders = row[customCol.value];
            if (Array.isArray(orders)) {
              orders.forEach(order => {
                allTargets.push(order);
              });
            }
            }
          });
        }
      });
      
      return allTargets;
    },

    getTargetIdValue(targetId) {
      return String(targetId || '').trim();
    },

    getRowTargetIds(row) {
      if (!row || !Array.isArray(row.targets_booker)) return [];

      return row.targets_booker
        .filter(order => order && !order.hide)
        .map(order => this.getTargetIdValue(order.target_id))
        .filter(Boolean);
    },

    getSelectableTargetIdsInTable() {
      if (!Array.isArray(this.data)) return [];

      const ids = this.data.flatMap(row => this.getRowTargetIds(row));
      return [...new Set(ids)];
    },

    getTotalSelectableTargetsInTable() {
      return this.getSelectableTargetIdsInTable().length;
    },

    isAllTargetsInTableSelected() {
      const allIds = this.getSelectableTargetIdsInTable();
      if (allIds.length === 0) return false;

      return allIds.every(targetId => this.selectedTargets.includes(targetId));
    },

    toggleAllTargetsInTable() {
      const allIds = this.getSelectableTargetIdsInTable();
      if (allIds.length === 0) return;

      if (this.isAllTargetsInTableSelected()) {
        this.selectedTargets = this.selectedTargets.filter(id => !allIds.includes(id));
        return;
      }

      const mergedIds = new Set([
        ...this.selectedTargets.map(id => this.getTargetIdValue(id)),
        ...allIds,
      ]);
      this.selectedTargets = Array.from(mergedIds);
    },

    isRowTargetsSelected(row) {
      const rowIds = this.getRowTargetIds(row);
      if (rowIds.length === 0) return false;

      return rowIds.every(targetId => this.selectedTargets.includes(targetId));
    },

    toggleRowTargetsSelection(row) {
      const rowIds = this.getRowTargetIds(row);
      if (rowIds.length === 0) return;

      if (this.isRowTargetsSelected(row)) {
        this.selectedTargets = this.selectedTargets.filter(id => !rowIds.includes(id));
        return;
      }

      const mergedIds = new Set([
        ...this.selectedTargets.map(id => this.getTargetIdValue(id)),
        ...rowIds,
      ]);
      this.selectedTargets = Array.from(mergedIds);
    },

    hasTargetsListColumn() {
      if (!Array.isArray(this.cols)) return false;
      return this.cols.some(colGroup => Array.isArray(colGroup) && colGroup.some(col => col && col.type === 'targetsList'));
    },
    
    selectAllTargetsInTable() {
      this.toggleAllTargetsInTable();
    },
    
    clearAllTargetsInTable() {
      this.selectedTargets = [];
    },
    
    hasAnySelectedTargets() {
      return this.selectedTargets.length > 0;
    },
    
    getTotalSelectedCount() {
      return this.selectedTargets.length;
    },
    
    async processAllSelectedTargets() {
      // Use the same logic as getTotalSelectedCount()
      if (this.selectedTargets.length === 0) {
        this.$swal({
          title: 'No Selection',
          text: 'Please select at least one target to process.',
          icon: 'warning',
          confirmButtonText: 'OK'
        });
        return;
      }
      
      const allTargets = this.getAllTargetsInTable();
      const selectedOrders = allTargets.filter(order => this.selectedTargets.includes(order.target_id));
      
      // Remove duplicates based on target_id
      const uniqueOrders = selectedOrders.reduce((acc, current) => {
        const existing = acc.find(order => order.target_id === current.target_id);
        if (!existing) {
          acc.push(current);
        }
        return acc;
      }, []);
      
      this.batchProcessing = true;
      this.batchProgress = 0;
      this.batchTotal = uniqueOrders.length;
      this.batchResults = [];
      
      // Show initial progress notification
      this.showBatchProgress();
      
      // Log duplicate removal info
      if (selectedOrders.length !== uniqueOrders.length) {
        console.log(`Removed ${selectedOrders.length - uniqueOrders.length} duplicate targets. Processing ${uniqueOrders.length} unique targets.`);
      }
      
      try {
        for (let i = 0; i < uniqueOrders.length; i++) {
          // Check if processing was cancelled
          if (!this.batchProcessing) {
            break;
          }
          
          const order = uniqueOrders[i];
          this.batchProgress = i + 1;
          
          try {
            const response = await targetsService.createTasks(order.target_id);
            this.batchResults.push({
              targetId: order.target_id,
              label: order.label,
              success: true,
              response: response
            });
            
            // Update progress popup with current result
            this.updateBatchProgress();
            
            // Don't show individual success notifications - results are shown in the main progress popup
            
          } catch (error) {
            // Extract error message
            let errorMessage = this.$t('lang.taskGeneration.noMoreContacts');
            let isNoMoreContacts = false;
            
            if (error.response) {
              // Server responded with error status
              const dataMessage = error.response.data && error.response.data.message;
              const status = error.response.status;
              
              // Check if it's a 500 error with no more contacts message
              if (status === 500 && dataMessage && dataMessage.includes('no more contacts')) {
                errorMessage = this.$t('lang.taskGeneration.noMoreContacts');
                isNoMoreContacts = true;
              } else {
                errorMessage = `HTTP ${status}: ${dataMessage || error.response.statusText}`;
              }
            } else if (error.message) {
              // Network or other error
              errorMessage = error.message;
            }
            
            this.batchResults.push({
              targetId: order.target_id,
              label: order.label,
              success: false,
              error: {
                message: errorMessage,
                status: error.response && error.response.status,
                data: error.response && error.response.data,
                isNoMoreContacts: isNoMoreContacts
              }
            });
            
            // Update progress popup with current result
            this.updateBatchProgress();
            
            // Don't show individual error notifications - errors are shown in the main progress popup
          }
          
          // Small delay between requests
          await new Promise(resolve => setTimeout(resolve, 500));
        }
        
        // Show final summary only if processing wasn't cancelled
        if (this.batchProcessing) {
          this.showBatchSummary();
        }
        
      } catch (error) {
        console.error('Batch processing error:', error);
      } finally {
        this.batchProcessing = false;
        this.selectedTargets = [];
      }
    },
    
    showBatchProgress() {
      this.$swal({
        title: this.$t('lang.taskGeneration.batchProcessing'),
        html: this.getBatchProgressHtml(),
        icon: 'info',
        showConfirmButton: false,
        showCancelButton: true,
        cancelButtonText: this.$t('lang.taskGeneration.cancel'),
        cancelButtonColor: '#dc3545',
        allowOutsideClick: false,
        allowEscapeKey: false,
        position: 'top-end',
        width: '400px',
        customClass: {
          popup: 'swal-batch-progress'
        }
      }).then((result) => {
        if (result.dismiss === 'cancel') {
          this.cancelBatchProcessing();
        }
      });
    },

    getBatchProgressHtml() {
      const progressPercent = (this.batchProgress / this.batchTotal) * 100;
      const successCount = this.batchResults.filter(r => r.success).length;
      const errorCount = this.batchResults.filter(r => !r.success).length;
      const totalTasks = this.batchResults
        .filter(r => r.success)
        .reduce((sum, r) => sum + (r.response && r.response.tasks_created || 0), 0);
      
      // Check if there were duplicates removed
      const originalSelectedCount = this.selectedTargets.length;
      const uniqueCount = this.batchTotal;
      const duplicatesRemoved = originalSelectedCount - uniqueCount;

      let resultsHtml = '';
      if (this.batchResults.length > 0) {
        resultsHtml = `
          <div class="mt-3">
            <h6 class="text-left mb-2">${this.$t('lang.taskGeneration.processing')}:</h6>
            <div class="text-left" style="max-height: 150px; overflow-y: auto;">
        `;
        
        this.batchResults.forEach(result => {
          const statusIcon = result.success ? '✅' : '❌';
          const tasksCreated = result.success ? (result.response && result.response.tasks_created || 0) : 0;
          let resultText = '';
          
          if (result.success) {
            resultText = `+${tasksCreated} ${this.$t('lang.taskGeneration.tasksCreated').toLowerCase()}`;
          } else {
            if (result.error && result.error.isNoMoreContacts) {
              resultText = result.error.message;
            } else {
              resultText = `Error: ${result.error && result.error.message || 'Unknown error'}`;
            }
          }
          
          resultsHtml += `
            <div class="mb-1 small ${result.success ? 'text-success' : 'text-danger'}">
              ${statusIcon} <strong>${result.targetId}:</strong> ${resultText}
            </div>
          `;
        });
        
        resultsHtml += `
            </div>
          </div>
        `;
      }

      return `
        <div class="text-center">
          <div class="mb-3">
            <div class="progress" style="height: 25px; border-radius: 10px;">
              <div class="progress-bar progress-bar-striped progress-bar-animated bg-primary" 
                   role="progressbar" 
                   style="width: ${progressPercent}%"
                   aria-valuenow="${this.batchProgress}" 
                   aria-valuemin="0" 
                   aria-valuemax="${this.batchTotal}">
                <strong>${this.batchProgress}/${this.batchTotal}</strong>
              </div>
            </div>
          </div>
          
          <div class="mb-2">
            <i class="fas fa-spinner fa-spin text-primary"></i>
            <span class="ml-2">${this.$t('lang.taskGeneration.processing')}</span>
          </div>
          
          ${duplicatesRemoved > 0 ? `
            <div class="alert alert-info alert-sm mb-2">
              <i class="fas fa-info-circle"></i>
              <small>${this.$t('lang.taskGeneration.duplicatesRemoved').replace('{count}', duplicatesRemoved).replace('{unique}', uniqueCount)}</small>
            </div>
          ` : ''}
          
          <div class="row mb-2">
            <div class="col-4">
              <div class="text-success">
                <strong>${successCount}</strong><br>
                <small>${this.$t('lang.taskGeneration.successful')}</small>
              </div>
            </div>
            <div class="col-4">
              <div class="text-danger">
                <strong>${errorCount}</strong><br>
                <small>${this.$t('lang.taskGeneration.failed')}</small>
              </div>
            </div>
            <div class="col-4">
              <div class="text-info">
                <strong>${totalTasks}</strong><br>
                <small>${this.$t('lang.taskGeneration.tasksCreated')}</small>
              </div>
            </div>
          </div>
          
          ${errorCount > 0 ? `
            <div class="alert alert-warning alert-sm mb-2">
              <i class="fas fa-exclamation-triangle"></i>
              <small>${this.$t('lang.taskGeneration.someErrorsOccurred')}</small>
            </div>
          ` : ''}
          
          ${resultsHtml}
          
          <p class="mb-0 text-muted small">${this.$t('lang.taskGeneration.pleaseWait')}</p>
        </div>
      `;
    },

    updateBatchProgress() {
      // Update the existing SweetAlert with new content
      if (this.$swal.isVisible()) {
        this.$swal.update({
          html: this.getBatchProgressHtml()
        });
      }
    },

    cancelBatchProcessing() {
      // Stop the batch processing
      this.batchProcessing = false;
      this.selectedTargets = [];
      
      // Close the progress popup
      this.$swal.close();
      
      // Show cancellation message
      this.$swal({
        title: this.$t('lang.taskGeneration.cancelled'),
        text: this.$t('lang.taskGeneration.processingCancelled'),
        icon: 'warning',
        confirmButtonText: this.$t('lang.taskGeneration.understood'),
        confirmButtonColor: '#ffc107',
        position: 'top-end',
        width: '300px'
      });
    },
    
    showBatchResult(label, data, success) {
      const resultType = success ? 'success' : 'error';
      const icon = success ? '✅' : '❌';
      const tasksCreated = success ? data.tasks_created : 0;
      const errorMessage = success ? '' : (data.error || this.$t('lang.taskGeneration.errorMessage'));
      const isNoMoreContacts = data.isNoMoreContacts || false;
      
      this.$swal({
        title: `${icon} ${label}`,
        text: success ? `+${tasksCreated} ${this.$t('lang.taskGeneration.tasksCreated').toLowerCase()}` : errorMessage,
        icon: resultType,
        timer: success ? 2000 : (isNoMoreContacts ? 3000 : 4000),
        showConfirmButton: false,
        position: 'top-end',
        width: '300px',
        customClass: {
          popup: 'swal-batch-result'
        }
      });
    },
    
    showBatchSummary() {
      // Close the progress popup first
      this.$swal.close();
      
      const successCount = this.batchResults.filter(r => r.success).length;
      const errorCount = this.batchResults.filter(r => !r.success).length;
      const totalTasks = this.batchResults
        .filter(r => r.success)
        .reduce((sum, r) => sum + (r.response && r.response.tasks_created || 0), 0);
      
      this.$swal({
        title: this.$t('lang.taskGeneration.batchComplete'),
        html: `
          <div class="text-center">
            <div class="row mb-3">
              <div class="col-6">
                <div class="card bg-success text-white">
                  <div class="card-body p-2">
                    <h5 class="mb-1">${successCount}</h5>
                    <small>${this.$t('lang.taskGeneration.successful')}</small>
                  </div>
                </div>
              </div>
              <div class="col-6">
                <div class="card bg-danger text-white">
                  <div class="card-body p-2">
                    <h5 class="mb-1">${errorCount}</h5>
                    <small>${this.$t('lang.taskGeneration.failed')}</small>
                  </div>
                </div>
              </div>
            </div>
            <div class="alert alert-info">
              <strong>${totalTasks}</strong> ${this.$t('lang.taskGeneration.totalProcessed')} ${this.$t('lang.taskGeneration.tasksCreated').toLowerCase()}
            </div>
          </div>
        `,
        icon: 'success',
        confirmButtonText: this.$t('lang.taskGeneration.perfect'),
        confirmButtonColor: '#28a745',
        position: 'top-end',
        width: '320px',
        customClass: {
          popup: 'swal-batch-summary'
        }
      });
    },
    
    confirmRemoveOrder(bookerId, targetId, targetLabel) {
      this.$swal({
        title: 'Are you sure?',
        text: `Do you want to remove the order "${targetLabel}"?`,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#d33',
        cancelButtonColor: '#3085d6',
        confirmButtonText: 'Yes, remove it!',
        cancelButtonText: 'Cancel'
      }).then((result) => {
        if (result.isConfirmed) {
          // Emit the removeOrder event only if user confirms
          this.$emit('removeOrder', { bookerId, targetId });
          
          // Show success message
          this.$swal({
            title: 'Removed!',
            text: `Campaign "${targetLabel}" has been removed.`,
            icon: 'success',
            timer: 2000,
            showConfirmButton: false
          });
        }
      });
    }
  }
};
</script>

<style scoped>
.booking-signal-badge {
  display: inline-block;
  border-radius: 4px;
  padding: 2px 8px;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.02em;
  text-transform: uppercase;
  white-space: nowrap;
  cursor: default;
}

.comment-icon-warning img {
  filter: brightness(0) saturate(100%) invert(27%) sepia(98%) saturate(5000%) hue-rotate(350deg);
}

.icon-small {
  font-size: 0.8rem !important;
}

.w100p {
  width: 100px;
}

.overflowtable>span {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  cursor: pointer;
}

.ellipsis {
  text-overflow: ellipsis;
}

.overflowhide>span {
  overflow: hidden;
  white-space: nowrap;
  cursor: pointer;
}

.overflowtable:hover {
  position: relative;
  padding: 0;
  vertical-align: inherit;
  text-align: left;
}

.overflowtable:hover>span {
  cursor: pointer;
  overflow: inherit;
  width: 100% !important;
  z-index: 999;
  position: absolute;
  border: 0;
  margin-top: -12px;
  margin-left: 12px;
  text-align: left;
  padding: 0;
  max-width: 100%;
  white-space: normal;
  background: rgb(236 236 236);
}

tr.table-primary .overflowtable:hover>span {
  background: #b7b9f6;
}

.noselect {
  -webkit-touch-callout: none;
  /* iOS Safari */
  -webkit-user-select: none;
  /* Safari */
  -khtml-user-select: none;
  /* Konqueror HTML */
  -moz-user-select: none;
  /* Old versions of Firefox */
  -ms-user-select: none;
  /* Internet Explorer/Edge */
  user-select: none;
  /* Non-prefixed version, currently
                                  supported by Chrome, Edge, Opera and Firefox */
}

.overflowtable:hover>span>span {}

#mytable .closed {
  display: none;
}

#mytable .opened {
  -webkit-animation: fadeIn 0.4s;
  animation: fadeIn 0.4s;
}

#mytable .openedlast {
  border-right: 2px solid #dee2e6;
}

/* .table {
  width: auto !important;
} */
table {
  width: 100%;
}

.label-hover {
  display: inline-block;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  max-width: 100%;
}

.label-hover:hover {
  white-space: normal;
  overflow: visible;
  text-overflow: clip;
}

select.no-arrow {
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
  background-image: none !important;
}

/* SweetAlert custom styles */
.swal-wide {
  width: 500px !important;
}

.swal-wide .swal2-html-container {
  margin: 0 !important;
  padding: 0 !important;
}

.swal-wide .card {
  border: none !important;
  box-shadow: 0 2px 4px rgba(0,0,0,0.1) !important;
}

.swal-wide .alert {
  border: none !important;
  border-radius: 8px !important;
}

/* Batch processing notifications */
.swal-batch-progress {
  position: fixed !important;
  top: 20px !important;
  right: 20px !important;
  z-index: 9999 !important;
}

.swal-batch-result {
  position: fixed !important;
  top: 20px !important;
  right: 20px !important;
  z-index: 9998 !important;
  margin-top: 10px !important;
}

.swal-batch-summary {
  position: fixed !important;
  top: 20px !important;
  right: 20px !important;
  z-index: 9997 !important;
  margin-top: 20px !important;
}

/* Stack notifications vertically */
.swal2-container.swal2-top-end .swal2-popup {
  margin-top: 10px !important;
}

/* Batch controls styling */
.batch-controls {
  background: #f8f9fa;
  border: 1px solid #dee2e6;
  border-radius: 5px;
  padding: 8px;
  margin-bottom: 10px;
}

.batch-controls .btn {
  font-size: 0.8rem;
  padding: 0.25rem 0.5rem;
}

/* Global batch controls in tfoot */
tfoot.bg-light {
  background-color: #f8f9fa !important;
  border-top: 2px solid #dee2e6;
}

tfoot .btn {
  font-size: 0.9rem;
  padding: 0.375rem 0.75rem;
}

/* Checkbox styling for targets */
input[type="checkbox"] {
  transform: scale(1.2);
  margin-right: 8px;
}

/* Disabled state for checkboxes during processing */
input[type="checkbox"]:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

/* Fixed batch controls at top */
.batch-controls-fixed {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1000;
  background: #f8f9fa;
  border-bottom: 2px solid #dee2e6;
  padding: 10px 20px;
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
}

/* Add top margin to table when batch controls are visible */
.table-with-batch-controls {
  margin-top: 60px;
}

/* Batch processing animations */
.batch-processing {
  animation: pulse 2s infinite;
}

@keyframes pulse {
  0% {
    opacity: 1;
  }
  50% {
    opacity: 0.5;
  }
  100% {
    opacity: 1;
  }
}

.btn-loading {
  position: relative;
}
.btn-loading:after {
  position: absolute;
  display: block;
  content: " ";
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  background: linear-gradient(
    110deg,
    rgba(236, 236, 236, 0.3) 8%,
    rgba(245, 245, 245, 0.5) 18%,
    rgba(236, 236, 236, 0.3) 33%
  );
  border-radius: 5px;
  background-size: 200% 100%;
  animation: 1.8s shine linear infinite;
}

@keyframes shine {
  to {
    background-position-x: -200%;
  }
}

/* Spinner animation for individual buttons */
.btn-processing {
  position: relative;
  pointer-events: none;
}

.btn-processing::after {
  content: '';
  position: absolute;
  width: 16px;
  height: 16px;
  margin: auto;
  border: 2px solid transparent;
  border-top-color: #ffffff;
  border-radius: 50%;
  animation: spin 1s linear infinite;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

/* SweetAlert custom styles */
.swal-batch-progress .swal2-popup {
  border-radius: 15px;
  box-shadow: 0 10px 30px rgba(0,0,0,0.2);
}

.swal-batch-result .swal2-popup {
  border-radius: 10px;
  box-shadow: 0 5px 15px rgba(0,0,0,0.1);
}

.swal-batch-summary .swal2-popup {
  border-radius: 15px;
  box-shadow: 0 10px 30px rgba(0,0,0,0.2);
}

.situation-tone-cell {
  min-width: 2.25rem;
  min-height: 2.25rem;
  padding: 0.25rem 0.5rem;
}

.situation-tone-cell--has-tone {
  position: relative;
}

.situation-tone-badge {
  position: absolute;
  right: -0.15rem;
  bottom: -0.1rem;
  font-size: 0.65rem;
  line-height: 1;
  background: #fff;
  border-radius: 50%;
  padding: 0.05rem;
  pointer-events: none;
}

.situation-tone-badge--warning {
  color: #f9a825;
}

.situation-tone-badge--danger {
  color: #c62828;
}

.situation-tone--ok {
  background: #e8f5e9;
  border: 1px solid #a5d6a7;
}

.situation-tone--warning {
  background: #fff8e1;
  border: 1px solid #ffe082;
}

.situation-tone--danger {
  background: #ffebee;
  border: 1px solid #ef9a9a;
}

.situation-tone--loading {
  background: #f5f5f5;
  border: 1px solid #e0e0e0;
}

.situation-tone-spinner {
  width: 0.95rem;
  height: 0.95rem;
  border-width: 0.15em;
  color: #6c757d;
}

tr.import-progress-row--warmup td {
  background-color: #f5f5f5 !important;
}

tr.import-progress-row--no-sr td {
  background-color: #ffebee !important;
}

tr.import-progress-row--no-sr-blocked td {
  background-color: #fff8e1 !important;
}

tr.import-progress-row--no-sr-running td {
  background-color: #e8f5e9 !important;
}
</style>

